(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rly-bestseller-models"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initBmSection(root) {
    var cards = root.querySelectorAll('.rly-bm__card');
    cards.forEach(function (card) {
      var primaryImg = card.querySelector('[data-card-primary]');
      var hoverImg = card.querySelector('[data-card-hover]');
      var linkEls = card.querySelectorAll('[data-card-link]');
      var priceWas = card.querySelector('[data-card-price-was]');
      var priceNow = card.querySelector('[data-card-price-now]');
      var badge = card.querySelector('[data-card-badge]');
      var swatches = card.querySelectorAll('[data-swatch]');

      swatches.forEach(function (sw) {
        sw.addEventListener('click', function (e) {
          e.preventDefault();
          var primary = sw.getAttribute('data-primary');
          var hover = sw.getAttribute('data-hover');
          var url = sw.getAttribute('data-url');
          var label = sw.getAttribute('data-label');
          var pNow = sw.getAttribute('data-price-now');
          var pWas = sw.getAttribute('data-price-was');
          var disc = sw.getAttribute('data-discount');

          if (primaryImg && primary) {
            primaryImg.removeAttribute('srcset');
            primaryImg.src = primary;
            if (label) primaryImg.alt = label;
          }
          if (hoverImg) {
            if (hover) {
              hoverImg.removeAttribute('srcset');
              hoverImg.src = hover;
              hoverImg.style.display = '';
            } else {
              hoverImg.removeAttribute('src');
              hoverImg.style.display = 'none';
            }
          }
          if (url) {
            linkEls.forEach(function (a) { a.setAttribute('href', url); });
          }
          if (priceNow && pNow) priceNow.textContent = pNow;
          if (priceWas) {
            if (pWas) {
              priceWas.textContent = pWas;
              priceWas.style.display = '';
            } else {
              priceWas.style.display = 'none';
              priceWas.textContent = '';
            }
          }
          if (badge) {
            if (disc) {
              badge.textContent = 'Save ' + disc + '%';
              badge.style.display = '';
            } else {
              badge.style.display = 'none';
            }
          }

          swatches.forEach(function (s) { s.classList.remove('is-active'); });
          sw.classList.add('is-active');
        });
      });
    });
  }

  function initAll() {
    document.querySelectorAll('.rly-bm').forEach(initBmSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Re-init when the section is loaded/reloaded in the theme editor
  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector('.rly-bm');
    if (section) initBmSection(section);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rly-helmet-product"]) return;
  try {
    
/* ============================================================
   RLY HELMET PDP RUNTIME — 1:1 port van de Claude Design export
   (design-desktop-script.js + design-mobile-script.js).
   De markup-templates zijn letterlijke kopieën van de export;
   deze runtime doet wat de design-runtime (DCLogic) deed:
   sc-for / sc-if / mustache-bindingen renderen vanuit renderVals().
   Aanpassingen t.o.v. de export (afgesproken met Alessya):
   - add-on prijzen in dollars i.p.v. euro's
   - maattabel S 54-58 / M 59-62 / L 63-66 cm
   - specs: Weight en Construction ingevuld
   - prijzen komen uit echte Shopify-variantdata (RVH_PRODUCT)
   - ATC voegt de echte variant toe aan de cart (Horizon-drawer)
   ============================================================ */
(function () {
  if (window.__rvhBooted) return; window.__rvhBooted = true;

  var ASSETS = window.RVH_ASSETS || {};
  var PRODUCT = window.RVH_PRODUCT || { title: 'Rally Vision Helmet', variants: [] };
  var ADDONS = window.RVH_ADDONS || {}; // echte add-on-producten (handle -> varianten)
  function asset(name) { return ASSETS[name] || ''; }
  // perf-port #39: CDN-breedte per gebruikscontext; negeert de parameter
  // gewoon als de CDN 'm niet ondersteunt (dan zelfde beeld als voorheen)
  function assetW(name, w) {
    var u = asset(name);
    if (!u || !w) return u;
    return u + (u.indexOf('?') === -1 ? '?' : '&') + 'width=' + w;
  }
  function withWidth(url, w) {
    if (!url || !w) return url;
    return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=' + w;
  }
  function money(cents) { return '$' + Math.round(cents / 100); }
  // Echte reviews — geladen uit assets/rly-helmet-reviews.js (defer; bij boot
  // — na DOMContentLoaded — zijn alle deferred scripts al uitgevoerd)
  var REVIEWS = [];
  function addonVariantFor(handle, optionLabel) {
    var a = ADDONS[handle];
    if (!a || !a.variants || !a.variants.length) return null;
    if (optionLabel) {
      for (var i = 0; i < a.variants.length; i++) if (a.variants[i].option === optionLabel) return a.variants[i];
    }
    return a.variants[0];
  }

  /* ---------- expressie-evaluatie (mustache-bindingen) ---------- */
  var exprCache = {};
  function evalExpr(expr, scope) {
    expr = expr.trim();
    if (/^[\w$][\w$.]*$/.test(expr)) { // pad-notatie, ook met cijfers (featureRows.0)
      var parts = expr.split('.');
      var cur = scope;
      for (var i = 0; i < parts.length; i++) {
        if (cur == null) return undefined;
        cur = cur[parts[i]];
      }
      return cur;
    }
    var fn = exprCache[expr];
    if (!fn) {
      try { fn = exprCache[expr] = new Function('__s', 'with(__s){return(' + expr + ');}'); }
      catch (e) { exprCache[expr] = function () { return ''; }; return ''; }
    }
    try { return fn(scope); } catch (e) { return ''; }
  }
  var MOPEN = '{' + '{'; // nooit letterlijk in dit bestand: sectie is Liquid
  var MUSTACHE = /\{\{\s*([\s\S]+?)\s*\}\}/g;
  function interpolate(str, scope) {
    return str.replace(MUSTACHE, function (_, expr) {
      var v = evalExpr(expr, scope);
      return v == null ? '' : String(v);
    });
  }

  /* ---------- template-processing (op verse kloon) ---------- */
  // <!--rvh:for list="expr" as="x"--> ... <!--/rvh:for-->
  // <!--rvh:if value="expr"--> ... <!--/rvh:if-->
  function parseDirective(text) {
    var m = /^rvh:(for|if)\s+(.*)$/.exec(text.trim());
    if (!m) return null;
    var out = { kind: m[1], attrs: {} };
    m[2].replace(/([\w-]+)="([^"]*)"/g, function (_, k, v) { out.attrs[k] = v; return ''; });
    return out;
  }
  function processNode(el, scope) {
    // 1) directive-comments onder dit element afhandelen
    var child = el.firstChild;
    while (child) {
      var next = child.nextSibling;
      if (child.nodeType === 8) { // comment
        var d = parseDirective(child.nodeValue || '');
        if (d) {
          var closeTag = '/rvh:' + d.kind;
          var openTag = 'rvh:' + d.kind;
          var depth = 0, n = child.nextSibling, tplNodes = [], closeNode = null;
          while (n) {
            if (n.nodeType === 8) {
              var t = (n.nodeValue || '').trim();
              if (t.indexOf(openTag) === 0) depth++;
              else if (t === closeTag) {
                if (depth === 0) { closeNode = n; break; }
                depth--;
              }
            }
            tplNodes.push(n);
            n = n.nextSibling;
          }
          if (!closeNode) { child = next; continue; }
          // per item/conditie: klonen in een holder, holder verwerken
          // (zo werken ook directives die als DIRECTE siblings genest zijn)
          function renderBlock(blockScope) {
            var holder = el.ownerDocument.createElement('div');
            for (var ti = 0; ti < tplNodes.length; ti++) holder.appendChild(tplNodes[ti].cloneNode(true));
            processNode(holder, blockScope);
            while (holder.firstChild) el.insertBefore(holder.firstChild, child);
          }
          if (d.kind === 'for') {
            var list = evalExpr(interpDirectiveExpr(d.attrs.list), scope) || [];
            var as = d.attrs.as || 'item';
            for (var li = 0; li < list.length; li++) {
              var itemScope = Object.create(scope);
              itemScope[as] = list[li];
              renderBlock(itemScope);
            }
          } else { // if
            var cond = evalExpr(interpDirectiveExpr(d.attrs.value), scope);
            if (cond) renderBlock(scope);
          }
          // template-bron + markers opruimen
          for (var ri = 0; ri < tplNodes.length; ri++) el.removeChild(tplNodes[ri]);
          next = closeNode.nextSibling;
          el.removeChild(child);
          el.removeChild(closeNode);
          child = next; continue;
        }
      } else if (child.nodeType === 1) {
        processNode(child, scope);
      } else if (child.nodeType === 3) {
        processText(child, scope);
      }
      child = next;
    }
    // 2) attributen van dit element
    if (el.nodeType === 1 && el.attributes) {
      var attrs = Array.prototype.slice.call(el.attributes);
      for (var ai = 0; ai < attrs.length; ai++) {
        var a = attrs[ai];
        if (a.value.indexOf(MOPEN) === -1) continue;
        var name = a.name.toLowerCase();
        if (name.indexOf('on') === 0 && name.length > 2) { // onclick / oninput / onscroll
          var hm = /^\{\{\s*([\s\S]+?)\s*\}\}$/.exec(a.value);
          var hv = hm ? evalExpr(hm[1], scope) : null;
          el.removeAttribute(a.name);
          if (typeof hv === 'function') {
            el.__rvhH = el.__rvhH || {};
            el.__rvhH[name.slice(2)] = hv;
            // scroll bubbelt niet: markeren voor directe binding na de sync
            if (name === 'onscroll') el.setAttribute('data-rvh-scroll', '1');
          }
        } else {
          var nv = interpolate(a.value, scope);
          el.setAttribute(a.name, nv);
          if (name === 'value' && 'value' in el) el.value = nv;
        }
      }
      // src pas nu zetten (zie build.py: voorkomt fetch van letterlijke mustache-URL)
      if (el.hasAttribute && el.hasAttribute('data-rvh-src')) {
        el.setAttribute('src', el.getAttribute('data-rvh-src'));
        el.removeAttribute('data-rvh-src');
      }
    }
  }
  // list-attribuut: mustache er desnoods omheen weghalen, expressie eruit
  function interpDirectiveExpr(raw) {
    if (raw == null) return '';
    var m = /^\{\{\s*([\s\S]+?)\s*\}\}$/.exec(raw.trim());
    return m ? m[1] : raw;
  }
  function processText(node, scope) {
    var v = node.nodeValue;
    if (v && v.indexOf(MOPEN) !== -1) node.nodeValue = interpolate(v, scope);
  }

  /* ---------- DOM-sync (behoudt canvas, input-focus, scroll) ---------- */
  function syncChildren(live, fresh) {
    var lc = Array.prototype.slice.call(live.childNodes);
    var fc = Array.prototype.slice.call(fresh.childNodes);
    var max = Math.max(lc.length, fc.length);
    for (var i = 0; i < max; i++) {
      var a = lc[i], b = fc[i];
      if (!b) { live.removeChild(a); continue; }
      if (!a) { live.appendChild(b); continue; }
      if (a.nodeType !== b.nodeType) { live.replaceChild(b, a); continue; }
      if (a.nodeType === 3 || a.nodeType === 8) {
        if (a.nodeValue !== b.nodeValue) a.nodeValue = b.nodeValue;
        continue;
      }
      if (a.nodeType === 1) {
        if (a.tagName !== b.tagName || a.getAttribute('key') !== b.getAttribute('key')) {
          live.replaceChild(b, a); continue;
        }
        syncEl(a, b);
      }
    }
  }
  function syncEl(a, b) {
    var i, at;
    var old = Array.prototype.slice.call(a.attributes);
    for (i = 0; i < old.length; i++) if (!b.hasAttribute(old[i].name)) a.removeAttribute(old[i].name);
    var nw = Array.prototype.slice.call(b.attributes);
    for (i = 0; i < nw.length; i++) {
      at = nw[i];
      if (a.getAttribute(at.name) !== at.value) {
        a.setAttribute(at.name, at.value);
        if (at.name === 'value' && 'value' in a && a !== document.activeElement) a.value = at.value;
      }
    }
    a.__rvhH = b.__rvhH;
    syncChildren(a, b);
  }

  /* ---------- cart (zelfde aanpak als rly-vnext, vereenvoudigd) ---------- */
  function rvhSectionIds() {
    var ids = [], nodes = document.querySelectorAll('cart-items-component[data-section-id], cart-icon[data-section-id]');
    for (var i = 0; i < nodes.length; i++) {
      var sid = nodes[i].getAttribute('data-section-id');
      if (sid && ids.indexOf(sid) === -1) ids.push(sid);
    }
    return ids;
  }
  function rvhSkeleton(show) {
    document.body.classList.toggle('rly-cart-skeleton-active', !!show);
    var sk = document.querySelector('.rly-cart-skeleton');
    if (sk) { if (show) sk.removeAttribute('hidden'); else sk.setAttribute('hidden', ''); }
  }
  function rvhOpenDrawer() {
    var cd = document.querySelector('cart-drawer-component');
    if (!cd) return;
    if (typeof cd.open === 'function') cd.open();
    else if (typeof cd.showDialog === 'function') cd.showDialog();
  }
  function rvhVisibleCount(cart) {
    if (!cart || !cart.items) return 0;
    var n = 0;
    for (var i = 0; i < cart.items.length; i++) {
      var it = cart.items[i];
      var isGift = it.properties && (it.properties._gift === 'true' || it.properties._gift === true);
      if (!isGift) n += it.quantity || 0;
    }
    return n;
  }
  function rvhDispatchCartUpdate(cart, sections) {
    try {
      document.dispatchEvent(new CustomEvent('cart:update', {
        bubbles: true,
        detail: { resource: cart, sourceId: 'rly-helmet-atc', data: { source: 'rly-helmet-atc', sections: sections || {}, itemCount: rvhVisibleCount(cart) } }
      }));
    } catch (err) { /* nooit de add blokkeren */ }
  }
  var atcBusy = false;
  function rvhAddToCart(items, btnEl) {
    if (atcBusy || !items || !items.length) return;
    atcBusy = true;
    if (btnEl) btnEl.style.opacity = '0.75';
    rvhSkeleton(true);
    rvhOpenDrawer();
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items, sections: rvhSectionIds().join(','), sections_url: window.location.pathname })
    })
      .then(function (r) { return r.json().then(function (json) { return { ok: r.ok, json: json }; }); })
      .then(function (res) {
        if (!res.ok || res.json.status) throw new Error((res.json && (res.json.description || res.json.message)) || 'add failed');
        return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
          .then(function (r) { return r.json(); }).catch(function () { return null; })
          .then(function (cart) {
            rvhDispatchCartUpdate(cart, res.json.sections || {});
            rvhSkeleton(false);
            if (btnEl) btnEl.style.opacity = '';
          });
      })
      .catch(function () {
        rvhSkeleton(false);
        if (btnEl) btnEl.style.opacity = '';
      })
      .then(function () { atcBusy = false; });
  }

  /* ---------- Component (port van de design-Component) ---------- */
  function RVH(rootId, tplId, prefix, opts) {
    this.root = document.getElementById(rootId);
    var tplEl = document.getElementById(tplId);
    this.tpl = tplEl ? tplEl.content : null;
    this.prefix = prefix;
    this.opts = opts || {};
    this.state = { color: 0, size: 1, sizeGuideOpen: false, unit: 'inch', headInput: '', addonsOn: {}, addonVariant: {}, showAllAddons: false, addonInfoIndex: null, showSticky: false, faqOpen: {}, videoOrientation: 'landscape', specOpen: {}, audioOpen: false, reviewImg: null, showAllReviews: false, starFilter: null, galleryIndex: 0, reviewPage: 0, turnSide: null, turnClip: 'collapsed', turnPhase: 'fill' };
    this.toApplySize = null;
  }
  RVH.prototype.$id = function (name) {
    return this.root ? this.root.querySelector('[id="' + this.prefix + name + '"]') : null;
  };
  RVH.prototype.checkStickyNow = function () {
    var atc = this.$id('main-atc');
    if (!atc) return;
    var rect = atc.getBoundingClientRect();
    if (rect.height === 0) return;
    var show = rect.bottom < 0;
    if (show === this._showSticky) return;
    this._showSticky = show;
    var bar = this._stickyEl ? this._stickyEl() : null;
    if (bar) bar.style.display = show ? 'flex' : 'none';
  };
  RVH.prototype.setState = function (patch, cb) {
    if (typeof patch === 'function') patch = patch(this.state);
    for (var k in patch) if (Object.prototype.hasOwnProperty.call(patch, k)) this.state[k] = patch[k];
    this.render();
    if (cb) cb();
  };
  RVH.prototype.render = function () {
    if (!this.root || !this.tpl) return;
    var vals = this.renderVals();
    vals.asset = asset;
    var fresh = this.tpl.cloneNode(true); // DocumentFragment
    var holder = document.createElement('div');
    holder.appendChild(fresh);
    processNode(holder, vals);
    syncChildren(this.root, holder);
    // na elke render opnieuw koppelen (vervangt de oude 500ms-polling-intervals)
    if (this._bindGalleryScroll) this._bindGalleryScroll();
    if (this._mounted) { this.setupTurnCanvas(); this.setupProofVideo(); }
    // scroll-handlers (bubbelen niet) direct op de live elementen binden
    var scrollers = this.root.querySelectorAll('[data-rvh-scroll]');
    for (var si = 0; si < scrollers.length; si++) {
      (function (el) {
        if (el._rvhScrollBound) return;
        el._rvhScrollBound = true;
        el.addEventListener('scroll', function (e) {
          if (el.__rvhH && el.__rvhH.scroll) el.__rvhH.scroll(e);
        }, { passive: true });
      })(scrollers[si]);
    }
  };
  RVH.prototype.mount = function () {
    if (!this.root || !this.tpl) return;
    var self = this;
    this._mounted = true;
    this.render();
    // event-delegatie
    this.root.addEventListener('click', function (e) {
      var n = e.target;
      while (n && n !== self.root) {
        if (n.__rvhH && n.__rvhH.click) {
          if (n.tagName === 'A') { e.preventDefault(); e.stopPropagation(); }
          n.__rvhH.click(e);
          return;
        }
        // ankersprong (bv. naar reviews): IO mist instant-teleports soms,
        // dus daarna één expliciete sticky-check (bevinding r3-2)
        if (n.tagName === 'A' && (n.getAttribute('href') || '').charAt(0) === '#') {
          setTimeout(function () { self.checkStickyNow(); }, 200);
          return;
        }
        n = n.parentNode;
      }
    });
    this.root.addEventListener('input', function (e) {
      var n = e.target;
      while (n && n !== self.root) {
        if (n.__rvhH && n.__rvhH.input) { n.__rvhH.input(e); return; }
        n = n.parentNode;
      }
    });
    /* --- componentDidMount (port; sticky via IntersectionObserver, vnext-patroon) --- */
    this._showSticky = false;
    this._stickyEl = function () {
      var n = self.$id('sticky-atc');
      while (n && n !== self.root && !/position:\s*fixed/.test(n.getAttribute('style') || '')) n = n.parentElement;
      return n === self.root ? null : n;
    };
    var atcEl = this.$id('main-atc');
    if (atcEl && 'IntersectionObserver' in window) {
      this._stickyIO = new IntersectionObserver(function (entries) {
        var en = entries[0];
        var show = !en.isIntersecting && en.boundingClientRect.top < 0;
        if (show === self._showSticky) return;
        self._showSticky = show;
        var bar = self._stickyEl();
        if (bar) bar.style.display = show ? 'flex' : 'none';
      });
      this._stickyIO.observe(atcEl);
    }
    this._onGalleryScroll = function () {
      var el = self.$id('pdp-rail');
      if (!el || !el.clientWidth) return;
      var idx = Math.round(el.scrollLeft / el.clientWidth);
      if (idx !== self.state.galleryIndex) self.setState({ galleryIndex: idx });
    };
    this._bindGalleryScroll = function () {
      var el = self.$id('pdp-rail');
      if (el && el !== self._galleryEl) {
        if (self._galleryEl) self._galleryEl.removeEventListener('scroll', self._onGalleryScroll);
        el.addEventListener('scroll', self._onGalleryScroll, { passive: true });
        self._galleryEl = el;
      }
    };
    this._bindGalleryScroll();
    this.setupTurnCanvas();
    this.setupProofVideo();
    this._useCaseTimer = setInterval(function () {
      if (document.hidden) return; // geen werk in verborgen tabs
      var el = self.$id('usecase-rail');
      if (!el || !el.children.length || !el.clientWidth) return;
      var realCount = 6;
      var next = (self._ucIndex = (self._ucIndex == null ? 0 : self._ucIndex) + 1);
      if (!el.children[next]) return;
      el.scrollTo({ left: el.children[next].offsetLeft, behavior: 'smooth' });
      if (next >= realCount) {
        setTimeout(function () {
          if (!el.children[realCount]) return;
          var setWidth = el.children[realCount].offsetLeft - el.children[0].offsetLeft;
          el.scrollLeft -= setWidth;
          self._ucIndex = 0;
        }, 550);
      }
    }, 3000);
  };
  RVH.prototype.selectColor = function (i) {
    if (this.opts.resetGalleryOnColor) {
      this.setState({ color: i, galleryIndex: 0 });
      var el = this.$id('pdp-rail');
      if (el) el.scrollTo({ left: 0 });
    } else {
      this.setState({ color: i });
    }
  };
  /* --- turn-signal canvasanimatie (letterlijke port) --- */
  RVH.prototype.setupTurnCanvas = function () {
    var canvas = this.$id('turnCanvas');
    if (!canvas || canvas._refInit) return;
    canvas._refInit = true;
    var ctx = canvas.getContext('2d');
    var W = canvas.width, H = canvas.height, MID = W / 2;
    var imgs = {};
    var token = 0;
    function loadImage(src) {
      return new Promise(function (resolve, reject) {
        var im = new Image();
        im.onload = function () { resolve(im); };
        im.onerror = reject;
        im.src = src;
      });
    }
    function smoothstep(t) { return t * t * (3 - 2 * t); }
    function sleep(ms) { return new Promise(function (r) { setTimeout(r, ms); }); }
    var revealCanvas = document.createElement('canvas');
    revealCanvas.width = W; revealCanvas.height = H;
    var rctx = revealCanvas.getContext('2d');
    var mask = document.createElement('canvas');
    mask.width = W; mask.height = H;
    var mctx = mask.getContext('2d');
    function drawState(direction, progress, offMix, revealOpacity) {
      progress = progress || 0; offMix = offMix === undefined ? 1 : offMix; revealOpacity = revealOpacity === undefined ? 1 : revealOpacity;
      var off = direction === 'left' ? imgs.leftOff : imgs.rightOff;
      if (!imgs.base || !off) return;
      ctx.clearRect(0, 0, W, H);
      ctx.globalAlpha = 1;
      ctx.drawImage(imgs.base, 0, 0, W, H);
      if (offMix > 0) {
        ctx.globalAlpha = offMix;
        ctx.drawImage(off, 0, 0, W, H);
        ctx.globalAlpha = 1;
      }
      if (progress <= 0 || revealOpacity <= 0) return;
      rctx.clearRect(0, 0, W, H);
      rctx.globalCompositeOperation = 'source-over';
      rctx.drawImage(imgs.base, 0, 0, W, H);
      mctx.clearRect(0, 0, W, H);
      var feather = 22;
      if (direction === 'left') {
        var boundary = MID - progress * MID;
        var grad = mctx.createLinearGradient(boundary, 0, boundary + feather, 0);
        grad.addColorStop(0, 'rgba(0,0,0,0)');
        grad.addColorStop(1, 'rgba(0,0,0,1)');
        mctx.fillStyle = grad;
        mctx.fillRect(boundary, 0, MID - boundary + feather, H);
      } else {
        var boundary2 = MID + progress * (W - MID);
        var grad2 = mctx.createLinearGradient(boundary2 - feather, 0, boundary2, 0);
        grad2.addColorStop(0, 'rgba(0,0,0,1)');
        grad2.addColorStop(1, 'rgba(0,0,0,0)');
        mctx.fillStyle = grad2;
        mctx.fillRect(MID - feather, 0, boundary2 - MID + feather, H);
      }
      rctx.globalCompositeOperation = 'destination-in';
      rctx.drawImage(mask, 0, 0);
      rctx.globalCompositeOperation = 'source-over';
      ctx.globalAlpha = revealOpacity;
      ctx.drawImage(revealCanvas, 0, 0, W, H);
      ctx.globalAlpha = 1;
    }
    function tween(ms, fn, myToken) {
      return new Promise(function (resolve) {
        var start = performance.now();
        function tick(now) {
          if (myToken !== token) return resolve();
          var t = Math.min(1, (now - start) / ms);
          fn(t);
          if (t < 1) requestAnimationFrame(tick); else resolve();
        }
        requestAnimationFrame(tick);
      });
    }
    async function playSignal(direction) {
      var myToken = ++token;
      await tween(145, function (t) {
        var e = 1 - Math.pow(1 - t, 3);
        drawState(direction, 0, e, 0);
      }, myToken);
      if (myToken !== token) return;
      await sleep(70);
      for (var cycle = 0; cycle < 2; cycle++) {
        await tween(390, function (t) { drawState(direction, smoothstep(t), 1, 1); }, myToken);
        if (myToken !== token) return;
        await sleep(95);
        if (myToken !== token) return;
        await tween(120, function (t) { drawState(direction, 1, 1, 1 - smoothstep(t)); }, myToken);
        if (myToken !== token) return;
        drawState(direction, 0, 1, 0);
        await sleep(cycle === 0 ? 175 : 210);
        if (myToken !== token) return;
      }
      await tween(165, function (t) { drawState(direction, 0, 1 - smoothstep(t), 0); }, myToken);
      drawState(direction, 0, 0, 0);
    }
    // animatiebeelden pas laden als het canvas bijna in beeld is (perf-port #41)
    function loadAll() {
      if (imgs._loading) return;
      imgs._loading = true;
      Promise.all([
        loadImage(asset('pdp-control-03-turn-signal-anim-base.avif')),
        loadImage(asset('pdp-control-03-turn-signal-anim-left-off.avif')),
        loadImage(asset('pdp-control-03-turn-signal-anim-right-off.avif'))
      ]).then(function (r) {
        imgs.base = r[0]; imgs.leftOff = r[1]; imgs.rightOff = r[2];
        drawState('left', 0, 0, 0);
      });
    }
    if ('IntersectionObserver' in window) {
      var cio = new IntersectionObserver(function (entries) {
        if (entries[0].isIntersecting) { loadAll(); cio.disconnect(); }
      }, { rootMargin: '300px' });
      cio.observe(canvas);
    } else {
      loadAll();
    }
    canvas._rvhLoadAll = loadAll;
    this._playSignal = playSignal;
  };
  /* --- recording-proof video: klik-om-af-te-spelen (afspraak 2026-09-23).
         Geen autoplay; download begint pas bij klik. In de buurt scrollen
         haalt alleen de metadata op (paar KB) zodat hij direct start. --- */
  RVH.prototype.setupProofVideo = function () {
    var v = this.$id('proof-video');
    var btn = this.$id('proof-play');
    if (!v || v._rvhInit) return;
    var url = window.RVH_VIDEO_URL;
    if (!url) return; // geen video ingesteld: poster blijft gewoon staan
    v._rvhInit = true;
    function prime() {
      if (!v.getAttribute('src')) { v.preload = 'metadata'; v.src = url; }
    }
    function showBtn(show) { if (btn) btn.style.display = show ? 'flex' : 'none'; }
    function enableControls() {
      // na de eerste keer afspelen: native spelerbalk (duur + schuifje voor
      // terug/vooruit spoelen, afspraak 2026-09-24); eigen klik-toggle eraf,
      // anders vecht die met de native bediening
      if (v._rvhControls) return;
      v._rvhControls = true;
      v.setAttribute('controlsList', 'nodownload');
      v.controls = true;
      v.removeEventListener('click', toggle);
    }
    function toggle() {
      prime();
      if (v.paused) { v.play().then(function () { showBtn(false); enableControls(); }).catch(function () {}); }
      else { v.pause(); showBtn(true); }
    }
    if (btn) btn.addEventListener('click', toggle);
    v.addEventListener('click', toggle);
    v.addEventListener('ended', function () { if (!v._rvhControls) showBtn(true); });
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (en) {
        if (en[0].isIntersecting) { prime(); }
        else if (!v.paused) { v.pause(); if (!v._rvhControls) showBtn(true); } // uit beeld: pauzeren
      }, { rootMargin: '200px' });
      io.observe(v);
    }
  };
  RVH.prototype.runTurnAnimation = function (direction) {
    this.setupTurnCanvas();
    if (this._playSignal) this._playSignal(direction);
  };
  /* --- add-ons (prijzen in dollars, afspraak 2026-09-23; data uit export 5;
         prijzen komen uit de echte subproducten zodra RVH_ADDONS ze levert) --- */
  RVH.prototype.getAddonData = function () {
    var handles = ['64gb-microsd-card', 'skull-cap-3-pack', '2-year-warranty', 'protective-helmet-bag', 'helmet-lock'];
    var data = this.getAddonDesignData();
    for (var i = 0; i < data.length; i++) {
      data[i].handle = handles[i];
      var av = addonVariantFor(handles[i], null);
      if (av && av.price) {
        data[i].price = money(av.price);
        if (av.cap) data[i].oldPrice = money(av.cap);
      }
    }
    return data;
  };
  RVH.prototype.getAddonDesignData = function () {
    return [
      { name: '64GB microSD Card', img: asset('pdp-addon-01-microsd-64gb.avif'), price: '$25', oldPrice: '$29', discount: '14%', desc: 'Recording video requires a fast, reliable microSD card. This 64GB card keeps up with your helmet’s recordings and stores hours of ride footage.', bullets: ['Stores around 14 hours of footage', 'Enough for 4+ full 3-hour rides', 'Keep multiple long rides saved at once', 'More riding, less deleting and transferring footage'] },
      { name: 'Skull Cap (3-Pack)', img: asset('pdp-addon-02-skull-cap-3pack-black.avif'), variants: [{ label: 'Black', swatch: '#18181b', img: asset('pdp-addon-02-skull-cap-3pack-black.avif') }, { label: 'White', swatch: '#fff', img: asset('pdp-addon-02-skull-cap-3pack-white.avif') }], price: '$25', oldPrice: '$39', discount: '36%', desc: 'Stay cool and keep sweat out of your eyes on long rides. Designed to fit comfortably under your Rally Vision Helmet without adding bulk.', bullets: ['Highly breathable mesh keeps air flowing', 'Helps keep sweat off your face and out of your eyes', 'Ultra-thin fit won\u2019t interfere with your helmet', '3-pack \u2014 one on your head, one in the wash, one ready to go.'] },
      { name: '2-Year Extended Warranty', img: asset('pdp-addon-03-2-year-warranty.avif'), price: '$29', oldPrice: '$39', discount: '26%', desc: 'Double your warranty coverage from 1 year to 2 years and ride with extra peace of mind.', bullets: ['Full 2-year warranty coverage', 'Protection against manufacturing defects', 'Repair or replacement for covered issues', 'Added automatically to your helmet order'] },
      { name: 'Protective Helmet Bag', img: asset('pdp-addon-04-protective-helmet-bag.avif'), price: '$19', oldPrice: '$25', discount: '24%', desc: 'Keep your helmet protected from scratches, dust, and scuffs while storing or carrying it.', bullets: ['Soft, lightweight protective bag', 'Helps prevent scratches and surface scuffs', 'Easy drawstring closure', 'Ideal for storage and travel'] },
      { name: 'Helmet Lock', img: asset('pdp-addon-05-helmet-lock.avif'), price: '$29', oldPrice: '$39', discount: '26%', desc: 'Secure your helmet to your bike when you step away for a coffee, quick stop, or break.', bullets: ['4-digit combination lock \u2014 no keys needed', 'Flexible coiled cable is easy to carry', 'Loops through your helmet and bike in seconds', 'Compact enough to keep in a pocket or saddle bag'] }
    ];
  };
  RVH.prototype.renderAddons = function () {
    var self = this;
    var addonData = this.getAddonData();
    var visibleCount = this.state.showAllAddons ? addonData.length : 2;
    var visibleAddons = addonData.slice(0, visibleCount).map(function (a, i) {
      var on = !!self.state.addonsOn[i];
      var vi = self.state.addonVariant[i] || 0;
      var o = {};
      for (var k in a) o[k] = a[k];
      o.bg = on ? '#18181b' : '#e4e4e7';
      o.knobLeft = on ? '18px' : '2px';
      o.thumb = 'url("' + withWidth(a.variants ? a.variants[vi].img : a.img, 200) + '")';
      o.showVariants = on && !!a.variants;
      o.variantLabel = a.variants ? a.variants[vi].label : '';
      o.variantOpts = (a.variants || []).map(function (v, vj) {
        var vo = {};
        for (var vk in v) vo[vk] = v[vk];
        vo.border = vi === vj ? '#18181b' : 'transparent';
        vo.select = function () { self.setState(function (s) { var n = {}; for (var kk in s.addonVariant) n[kk] = s.addonVariant[kk]; n[i] = vj; return { addonVariant: n }; }); };
        return vo;
      });
      o.toggle = function () { self.setState(function (s) { var n = {}; for (var kk in s.addonsOn) n[kk] = s.addonsOn[kk]; n[i] = !s.addonsOn[i]; return { addonsOn: n }; }); };
      o.openInfo = function () { self.setState({ addonInfoIndex: i }); };
      return o;
    });
    return {
      visibleAddons: visibleAddons,
      hasMoreAddons: addonData.length > 2,
      showAllAddonsLabel: this.state.showAllAddons ? 'Show less' : 'Show all add-ons',
      showAllAddonsRotate: this.state.showAllAddons ? 'rotate(45deg)' : 'rotate(0deg)',
      toggleShowAllAddons: function () { self.setState(function (s) { return { showAllAddons: !s.showAllAddons }; }); },
      addonInfo: (function () {
        var i = self.state.addonInfoIndex;
        if (i == null) return null;
        var a = addonData[i], on = !!self.state.addonsOn[i], vi = self.state.addonVariant[i] || 0;
        var o = {};
        for (var k in a) o[k] = a[k];
        o.thumb = 'url("' + withWidth(a.variants ? a.variants[vi].img : a.img, 600) + '")';
        o.hasVariants = !!a.variants;
        o.variantLabel = a.variants ? a.variants[vi].label : '';
        o.variantOpts = (a.variants || []).map(function (v, j) {
          var vo = {};
          for (var vk in v) vo[vk] = v[vk];
          vo.border = vi === j ? '#18181b' : 'transparent';
          vo.select = function () { self.setState(function (s) { var n = {}; for (var kk in s.addonVariant) n[kk] = s.addonVariant[kk]; n[i] = j; return { addonVariant: n }; }); };
          return vo;
        });
        o.ctaLabel = on ? 'Added to cart' : 'Add to cart';
        o.bg = on ? '#18181b' : '#e4e4e7';
        o.knobLeft = on ? '18px' : '2px';
        o.addFromInfo = function () {
          if (on) { self.setState(function (s) { var n = {}; for (var kk in s.addonsOn) n[kk] = s.addonsOn[kk]; n[i] = false; return { addonsOn: n }; }); return; }
          self.setState(function (s) { var n = {}; for (var kk in s.addonsOn) n[kk] = s.addonsOn[kk]; n[i] = true; return { addonsOn: n, showAllAddons: s.showAllAddons || i >= 2 }; });
          setTimeout(function () { self.setState({ addonInfoIndex: null }); }, 350);
        };
        return o;
      })(),
      closeAddonInfo: function () { self.setState({ addonInfoIndex: null }); }
    };
  };
  /* --- echte variant bij huidige kleur+maat --- */
  RVH.prototype.colorNames = ['Midnight Black', 'Carbon', 'Arctic White']; // design-volgorde
  RVH.prototype.sizeLabels = ['S', 'M', 'L'];
  RVH.prototype.currentVariant = function () {
    var color = this.colorNames[this.state.color];
    var size = this.sizeLabels[this.state.size];
    var vs = PRODUCT.variants || [];
    for (var i = 0; i < vs.length; i++) {
      if (vs[i].color === color && vs[i].size === size) return vs[i];
    }
    return null;
  };
  /* --- renderVals (port, met echte productdata) --- */
  RVH.prototype.renderVals = function () {
    var self = this;
    var accentColor = '#ff6a13';
    var sizeLabels = this.sizeLabels;
    var sizes = sizeLabels.map(function (label, i) {
      return {
        label: label,
        border: self.state.size === i ? '#18181b' : '#e4e4e7',
        radius: i === 0 ? '8px 0 0 8px' : i === sizeLabels.length - 1 ? '0 8px 8px 0' : '0',
        marginLeft: i === 0 ? '0' : '-1px',
        z: self.state.size === i ? 2 : 1,
        select: function () { self.setState({ size: i }); }
      };
    });
    // Maattabel volgens Alessya: S 54-58 / M 59-62 / L 63-66 cm
    var guideRowsCm = [
      { size: 'S', lo: 54, hi: 58 },
      { size: 'M', lo: 59, hi: 62 },
      { size: 'L', lo: 63, hi: 66 }
    ];
    var isInch = this.state.unit === 'inch';
    var fmt = function (v) { return isInch ? (v / 2.54).toFixed(1) : v.toString(); };
    var guideRows = guideRowsCm.map(function (r) { return { size: r.size, range: fmt(r.lo) + ' - ' + fmt(r.hi) }; });
    var headVal = parseFloat(this.state.headInput);
    var matchedSize = '';
    if (!isNaN(headVal) && headVal > 0) {
      var cmVal = isInch ? headVal * 2.54 : headVal;
      var hit = null;
      for (var gi = 0; gi < guideRowsCm.length; gi++) {
        var r = guideRowsCm[gi];
        if (cmVal >= r.lo && cmVal < r.hi + 1) { hit = r; break; }
      }
      matchedSize = hit ? hit.size : '';
    }
    if (matchedSize) this.toApplySize = sizeLabels.indexOf(matchedSize);
    // Echte reviews (CSV): foto's en tekst gemixt over de eerste 7 pagina's
    // met wisselende posities, kortste reviews vooraan; daarna tekst met
    // gemixte lengtes — volgorde is voorgebakken (aanpassing 2026-09-23).
    var starFilter = this.state.starFilter;
    var reviewsFiltered = starFilter ? REVIEWS.filter(function (r) { return r.r === starFilter; }) : REVIEWS;
    var perPage = 4;
    var totalPages = Math.max(1, Math.ceil(reviewsFiltered.length / perPage));
    var page = Math.min(this.state.reviewPage || 0, totalPages - 1);
    var winStart = Math.max(0, Math.min(page - 1, totalPages - 3));
    var reviewPages = [];
    for (var p = winStart; p < Math.min(totalPages, winStart + 3); p++) {
      (function (p2) {
        reviewPages.push({ n: p2 + 1, bg: p2 === page ? '#18181b' : '#fff', color: p2 === page ? '#fff' : '#52525b', select: function () { self.setState({ reviewPage: p2 }); } });
      })(p);
    }
    var colorData = [
      { name: 'Midnight Black', swatch: '#1c1c1e', imgs: ['pdp-gallery-midnight-black-01-studio.avif', 'pdp-gallery-midnight-black-02-studio.avif', 'pdp-gallery-midnight-black-03-studio.avif', 'pdp-gallery-midnight-black-04-lifestyle.avif', 'pdp-gallery-midnight-black-05-lifestyle.avif', 'pdp-gallery-midnight-black-06-lifestyle.avif'] },
      { name: 'Carbon', swatch: '#2b2b2d', imgs: ['pdp-gallery-carbon-01-studio.avif', 'pdp-gallery-carbon-02-studio.avif', 'pdp-gallery-carbon-03-studio.avif', 'pdp-gallery-carbon-04-lifestyle.avif', 'pdp-gallery-carbon-05-lifestyle.avif', 'pdp-gallery-carbon-06-lifestyle.avif'] },
      { name: 'Arctic White', swatch: '#f4f4f5', imgBorder: true, imgs: ['pdp-gallery-arctic-white-01-studio.avif', 'pdp-gallery-arctic-white-02-studio.avif', 'pdp-gallery-arctic-white-03-studio.avif', 'pdp-gallery-arctic-white-04-lifestyle.avif', 'pdp-gallery-arctic-white-05-lifestyle.avif', 'pdp-gallery-arctic-white-06-lifestyle.avif'] }
    ];
    var colors = colorData.map(function (c, i) {
      var o = {};
      for (var k in c) o[k] = c[k];
      o.thumb = 'url("' + asset(c.imgs[1]) + '")';
      o.border = self.state.color === i ? '#18181b' : 'transparent';
      o.select = function () { self.selectColor(i); };
      return o;
    });
    var addons = this.renderAddons();
    var vals = {
      accentColor: accentColor,
      useCases: [
        { label: 'Road Cycling', img: assetW('pdp-usecase-01-road-cycling.avif', 800), pos: '48% 25%' },
        { label: 'E-Scootering', img: assetW('pdp-usecase-02-e-scootering.avif', 800), pos: '40% 30%' },
        { label: 'Mountain Biking', img: assetW('pdp-usecase-03-mountain-biking.avif', 800), pos: '38% 32%' },
        { label: 'E-Bike Riding', img: assetW('pdp-usecase-04-e-bike-riding.avif', 800), pos: '52% 30%' },
        { label: 'Gravel Riding', img: assetW('pdp-usecase-05-gravel-riding.avif', 800), pos: '48% 30%' },
        { label: 'Commuting', img: assetW('pdp-usecase-06-commuting.avif', 800), pos: '45% 35%' }
      ],
      get useCasesLoop() { return this.useCases.concat(this.useCases); },
      // Certificerings-sectie (export 6): fotowand-rijen (verdubbeld voor de
      // oneindige loop) + voortgangsbalkjes van de mobiele kaart-carrousel
      ugcRowA: (function () {
        var out = [], i;
        for (i = 1; i <= 14; i += 2) out.push({ img: 'url("' + assetW('pdp-social-proof-ugc-' + (i < 10 ? '0' : '') + i + '.avif', 400) + '")' });
        return out.concat(out);
      })(),
      ugcRowB: (function () {
        var out = [], i;
        for (i = 2; i <= 14; i += 2) out.push({ img: 'url("' + assetW('pdp-social-proof-ugc-' + (i < 10 ? '0' : '') + i + '.avif', 400) + '")' });
        return out.concat(out);
      })(),
      certBars: [0, 1, 2, 3].map(function (i) {
        var cur = self.state.certIdx || 0;
        return { flex: i === cur ? '0 0 64px' : '0 0 36px', bg: i === cur ? '#18181b' : '#d4d4d8' };
      }),
      onCertScroll: function (e) {
        var el = e.currentTarget, c = el.firstElementChild;
        if (!c) return;
        var i = Math.min(3, Math.round(el.scrollLeft / (c.offsetWidth + 10)));
        if (i !== (self.state.certIdx || 0)) self.setState({ certIdx: i });
      },
      get powerA() { return this.powerItems.slice(0, 3); },
      get powerB() { return this.powerItems.slice(3); },
      get powerQuad() { return this.powerItems.slice(0, 4); },
      get powerLast() { return this.powerItems.slice(4); },
      faqs: [
        { q: 'How do I start recording, and do I need my phone?', a: 'No phone needed. Just press the button on the included wireless handlebar remote to start or stop recording, without taking your hands off the bars.' },
        { q: 'Is the helmet safety certified?', a: 'Yes. The Rally Vision Helmet is dual-certified: it meets the US CPSC 16 CFR Part 1203 standard and the European CE · EN 1078 standard for bicycle helmets. Both involve independent impact, strap-strength and coverage testing, so the built-in camera, lights and speakers never come at the cost of protection.' },
        { q: 'How long can I record on a full charge?', a: 'Up to 3+ hours of continuous recording on a single charge.' },
        { q: 'Can I use the helmet in the rain?', a: 'Yes, IP65 rated for rain and dust. Do not submerge.' },
        { q: 'How do I choose the right size?', a: 'Measure your head circumference just above your ears and enter it in our Size Guide. We’ll match you to S, M or L and select it for you.', sizeLink: true },
        { q: 'Can I listen to music and take calls?', a: 'Yes, via Bluetooth 5.4 and the built-in speakers. FM radio is also included.' },
        { q: 'How do the turn signals work?', a: 'Rear left/right indicators and hazard lights are controlled with the included wireless handlebar remote.' }
      ].map(function (f, i) {
        var o = {};
        for (var k in f) o[k] = f[k];
        o.open = !!self.state.faqOpen[i];
        o.chev = self.state.faqOpen[i] ? 'rotate(180deg)' : 'rotate(0deg)';
        o.toggle = function () { self.setState(function (s) { var n = {}; for (var kk in s.faqOpen) n[kk] = s.faqOpen[kk]; n[i] = !s.faqOpen[i]; return { faqOpen: n }; }); };
        o.color = '#52525b';
        return o;
      }),
      stickyBarDisplay: this._showSticky ? 'flex' : 'none',
      // Bullets volgens Alessya (2026-09-23, aangepast later die dag)
      highlights: [
        'Independently Certified CPSC + EN 1078',
        '3+ Hours of Continuous Recording',
        'Capture Video Evidence While You Ride',
        'Stay Cool on Long Hot Rides',
        'Secure Comfortable Fit'
      ],
      sizes: sizes,
      sizeGuideOpen: this.state.sizeGuideOpen,
      openSizeGuide: function () { self.setState({ sizeGuideOpen: true }); },
      closeSizeGuide: function () { self.setState({ sizeGuideOpen: false }); },
      unit: this.state.unit,
      unitLabel: isInch ? 'in' : 'cm',
      unitPlaceholder: isInch ? '22.5' : '57',
      unitInchWeight: isInch ? 700 : 400,
      unitCmWeight: isInch ? 400 : 700,
      toggleLeft: isInch ? '18px' : '2px',
      toggleUnit: function () { self.setState(function (s) { return { unit: s.unit === 'cm' ? 'inch' : 'cm' }; }); },
      headInput: this.state.headInput,
      onHeadInput: function (e) {
        // debounced: niet bij elke toetsaanslag de hele template her-renderen
        self.state.headInput = e.target.value;
        clearTimeout(self._headInputTimer);
        self._headInputTimer = setTimeout(function () { self.render(); }, 150);
      },
      guideRows: guideRows,
      matchedSize: matchedSize,
      applyMatchedSize: function () {
        if (self.toApplySize == null) return;
        self.setState({ size: self.toApplySize, sizeGuideOpen: false }, function () {
          var el = self.$id('pdp-size');
          if (!el) return;
          var top = el.getBoundingClientRect().top + window.scrollY - 80;
          window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
        });
      },
      goBack: function () { history.back(); },
      selectedColor: colorData[this.state.color],
      selectedSizeLabel: sizeLabels[this.state.size],
      activeImage: 'url("' + asset(colorData[this.state.color].imgs[Math.min(this.state.galleryIndex, 5)]) + '")',
      activeBg: this.state.galleryIndex >= 3 ? '#e5e6e8' : '#f3f4f5',
      galleryPrev: function () { self.setState(function (s) { return { galleryIndex: (s.galleryIndex + 5) % 6 }; }); },
      galleryNext: function () { self.setState(function (s) { return { galleryIndex: (s.galleryIndex + 1) % 6 }; }); },
      colors: colors,
      activeGallery: colorData[this.state.color].imgs.map(function (im, i) {
        return {
          ph: '', img: 'url("' + asset(im) + '")', bg: i >= 3 ? '#e5e6e8' : '#f3f4f5',
          dotColor: i === self.state.galleryIndex ? '#18181b' : 'rgba(24,24,27,0.28)',
          dotSize: i === self.state.galleryIndex ? '7px' : '6px',
          select: function () { self.setState({ galleryIndex: i }); },
          thumbBorder: i === self.state.galleryIndex ? '#18181b' : 'transparent'
        };
      }),
      product: (function () {
        // Basisprijs uit de echte Shopify-variant ($149 / $219)
        var v = self.currentVariant();
        var basePrice = v ? Math.round(v.price / 100) : 149;
        var baseOld = v && v.cap ? Math.round(v.cap / 100) : 219;
        var addonData = self.getAddonData();
        var num = function (s) { return parseInt(String(s).replace(/[^0-9]/g, ''), 10); };
        var addonSum = 0, addonOldSum = 0;
        addonData.forEach(function (a, i) {
          if (self.state.addonsOn[i]) { addonSum += num(a.price); addonOldSum += num(a.oldPrice); }
        });
        var price = basePrice + addonSum, oldPrice = baseOld + addonOldSum;
        return {
          category: 'Smart Gear',
          name: PRODUCT.title || 'Rally Vision Helmet',
          price: '$' + price,
          oldPrice: '$' + oldPrice,
          discountLabel: '-' + Math.round((1 - price / oldPrice) * 100) + '%'
        };
      })(),
      addToCart: function (e) {
        var btn = e && e.target ? (e.target.closest ? e.target.closest('a') : null) : null;
        var v = self.currentVariant();
        if (!v || v.available === false) return;
        // helm + aangevinkte add-ons (echte subproducten; Skull Cap met gekozen kleur)
        var items = [{ id: Number(v.id), quantity: 1 }];
        var order = ['64gb-microsd-card', 'skull-cap-3-pack', '2-year-warranty', 'protective-helmet-bag', 'helmet-lock'];
        for (var i = 0; i < order.length; i++) {
          if (!self.state.addonsOn[i]) continue;
          var opt = order[i] === 'skull-cap-3-pack' ? (['Black', 'White'][self.state.addonVariant[i] || 0]) : null;
          var av = addonVariantFor(order[i], opt);
          if (av) items.push({ id: Number(av.id), quantity: 1 });
        }
        // eigen drawer (snippets/rly-helmet-drawer.liquid) regisseert de add
        // als hij geladen is; anders het oude pad (Horizon-drawer) als vangnet
        if (window.RVHDW && window.RVHDW.addAndOpen) {
          if (btn) btn.style.opacity = '0.75';
          window.RVHDW.addAndOpen(items).then(
            function () { if (btn) btn.style.opacity = ''; },
            function () { if (btn) btn.style.opacity = ''; }
          );
        } else {
          rvhAddToCart(items, btn);
        }
      },
      trust: [
        { label: 'Free Shipping $200+', icon: '<path d="M3 7h11v8H3z" stroke-linejoin="round"></path><path d="M14 10h4l3 3v2h-7z" stroke-linejoin="round"></path><circle cx="7" cy="18" r="1.6"></circle><circle cx="17" cy="18" r="1.6"></circle>' },
        { label: '30-Day Returns', icon: '<path d="M12 3l7 3v5c0 4.2-2.8 7.6-7 9-4.2-1.4-7-4.8-7-9V6l7-3z" stroke-linejoin="round"></path><path d="M9 12l2 2 4-4" stroke-linecap="round" stroke-linejoin="round"></path>' },
        { label: '2-Year Warranty', icon: '<circle cx="12" cy="12" r="9"></circle><path d="M12 7v5l3 3" stroke-linecap="round" stroke-linejoin="round"></path>' }
      ],
      triggerTurnLeft: function () { self.runTurnAnimation('left'); },
      triggerTurnRight: function () { self.runTurnAnimation('right'); },
      selectPortrait: function () { self.setState({ videoOrientation: 'portrait' }); },
      selectLandscape: function () { self.setState({ videoOrientation: 'landscape' }); },
      portraitBg: this.state.videoOrientation === 'portrait' ? '#18181b' : 'transparent',
      portraitColor: this.state.videoOrientation === 'portrait' ? '#fff' : '#52525b',
      landscapeBg: this.state.videoOrientation === 'landscape' ? '#18181b' : 'transparent',
      landscapeColor: this.state.videoOrientation === 'landscape' ? '#fff' : '#52525b',
      videoAspect: this.state.videoOrientation === 'portrait' ? '9/16' : '16/9',
      recordSteps: [
        { n: 1, label: 'Put on your helmet' },
        { n: 2, label: 'Press record' },
        { n: 3, label: 'Ride' }
      ],
      ratingBars: [5, 4, 3, 2, 1].map(function (s) {
        var c = 0;
        for (var i = 0; i < REVIEWS.length; i++) if (REVIEWS[i].r === s) c++;
        return { label: s + (s === 1 ? ' star' : ' stars'), pct: Math.round(c / (REVIEWS.length || 1) * 100) + '%', count: c };
      }),
      reviewImageOpen: this.state.reviewImg,
      closeReviewImage: function () { self.setState({ reviewImg: null }); },
      reviews: reviewsFiltered.slice(page * perPage, page * perPage + perPage).map(function (r) {
        var url = r.img ? assetW(r.img, 800) : null;
        return {
          text: r.t, author: r.a, rating: r.r, img: url,
          starPct: (r.r || 5) * 20,
          openImg: url ? function () { self.setState({ reviewImg: url }); } : null
        };
      }),
      showReviewPager: totalPages > 1,
      reviewPages: reviewPages,
      reviewPrevOpacity: page > 0 ? 1 : 0.35,
      reviewNextOpacity: page < totalPages - 1 ? 1 : 0.35,
      reviewPrev: function () { self.setState({ reviewPage: Math.max(0, page - 1) }); },
      reviewNext: function () { self.setState({ reviewPage: Math.min(totalPages - 1, page + 1) }); },
      starFilters: [5, 4, 3, 2, 1].map(function (n) {
        return {
          n: n,
          activeBg: starFilter === n ? '#18181b' : '#fff',
          activeColor: starFilter === n ? '#fff' : '#52525b',
          select: function () { self.setState({ starFilter: starFilter === n ? null : n, reviewPage: 0 }); }
        };
      }),
      extraBadges: [
        { title: 'Impact-Absorbing EPS', desc: 'Engineered to help absorb impact energy.' },
        { title: 'Secure Fit System', desc: 'Designed to stay stable and properly positioned.' }
      ],
      safetyPoints: [
        { title: 'CPSC Compliant', desc: 'Meets U.S. bicycle helmet safety requirements.', iconShield: true },
        { title: 'EN 1078 Compliant', desc: 'Meets European bicycle helmet safety requirements.', iconFoam: true },
        { title: 'Impact-Absorbing EPS', desc: 'Engineered to help absorb impact energy.', iconImpact: true },
        { title: 'Secure Fit System', desc: 'Designed for a stable, locked-in fit.', iconVent: true }
      ],
      compareRows: [
        { label: 'Hands-free recording', helmet: true, action: true, phone: false, glasses: true },
        { label: 'Records your POV without a mount', helmet: true, action: false, phone: false, glasses: true },
        { label: 'No extra mount needed', helmet: true, action: false, phone: true, glasses: true },
        { label: 'Protects your head', helmet: true, action: false, phone: false, glasses: false },
        { label: 'Built-in turn signals', helmet: true, action: false, phone: false, glasses: false },
        { label: 'Open-ear music & audio', helmet: true, action: false, phone: false, glasses: true },
        { label: 'Easy to record while riding', helmet: true, action: true, phone: false, glasses: true },
        { label: 'Made for cycling', helmet: true, action: false, phone: false, glasses: false }
      ].map(function (r) {
        var o = {};
        for (var k in r) o[k] = r[k];
        o.helmetNo = !r.helmet; o.actionNo = !r.action; o.phoneNo = !r.phone; o.glassesNo = !r.glasses;
        return o;
      }),
      powerItems: [
        { title: '3+ Hours Continuous Recording', desc: 'Record longer rides without stopping to restart the camera.', img: assetW('pdp-control-01-3-hour-recording.avif', 1000) },
        { title: 'Wireless Handlebar Remote', desc: 'Control key functions without taking your hands off the bars.', img: assetW('pdp-control-02-wireless-handlebar-remote.avif', 1000), freeGift: true },
        { title: 'Smart Turn Signals', desc: 'Signal left or right from your handlebars, so others see where you’re going.', img: assetW('pdp-control-03-smart-turn-signals.avif', 1000), turnButtons: true },
        { title: 'Rider-to-Rider Communication', desc: 'Talk with your riding group hands-free and take calls without reaching for your phone.', img: assetW('pdp-control-04-rider-communication.avif', 1000) },
        { title: 'Open-Ear Music & FM Radio', desc: 'Listen to music and radio while staying aware of the road around you.', img: assetW('pdp-control-05-music-fm-radio.avif', 1000) }
      ],
      whatsInBox: { title: "What's in the Box", img: assetW('pdp-box-contents.avif', 1200), items: [
        { n: 1, label: 'Rally Vision Helmet' },
        { n: 2, label: 'Wireless remote' },
        { n: 3, label: 'USB-C charging cable' },
        { n: 4, label: 'Quick start guide' },
        { n: 5, label: 'Rally Vision Helmet box' }
      ] },
      featureRows: [
        [{ title: 'Hands-Free POV Recording', desc: 'Just ride. It records.', img: assetW('pdp-features-01-handsfree-pov-recording.avif', 1800) }],
        [
          { title: '40-Hour Battery', desc: 'Charge once, ride all week.', img: assetW('pdp-features-02-40-hour-battery.avif', 1200) },
          { title: 'Music & Calls', desc: 'Listen and talk while you ride.', img: assetW('pdp-features-03-music-calls.avif', 1200) }
        ],
        [{ title: 'Smart Turn Signals', desc: "Show where you're going. Drivers see you sooner.", img: assetW('pdp-features-04-smart-turn-signals.avif', 1800) }],
        [
          { title: 'Rain-Proof', desc: 'Rain or shine, it keeps working.', img: assetW('pdp-features-05-rain-proof.avif', 1200) },
          { title: 'Wireless Remote', desc: 'Control everything from your handlebar.', img: assetW('pdp-features-06-wireless-remote.avif', 1200), pos: '50% 50%' }
        ],
        [{ title: 'Ventilated Airflow', desc: 'Stay cool on climbs with channels engineered to move air through, not around.', img: assetW('pdp-features-07-ventilated-airflow.avif', 1800), pos: '50% 35%' }]
      ],
      audioOpen: this.state.audioOpen,
      audioChev: this.state.audioOpen ? 'rotate(180deg)' : 'rotate(0deg)',
      audioToggle: function () { self.setState(function (s) { return { audioOpen: !s.audioOpen }; }); },
      specGroups: [
        {
          title: 'Helmet',
          rows: [
            { label: 'Weight', value: '430–450 g (15.2–15.9 oz)', color: '#18181b' },
            { label: 'Size & Fit', value: 'S / M / L (54–66 cm head circumference)', color: '#18181b' },
            { label: 'Ventilation', value: '12 vents', color: '#18181b' },
            { label: 'Construction', value: 'In-mold polycarbonate shell + EPS liner', color: '#18181b' },
            { label: 'Safety Certification', value: 'CPSC 16 CFR Part 1203 / CE · EN 1078', color: '#18181b' },
            { label: 'Weather Resistance', value: 'IP65', color: '#18181b' }
          ]
        },
        {
          title: 'Camera & Recording',
          rows: [
            { label: 'Video Quality', value: '1080P Full HD', color: '#18181b' },
            { label: 'Field of View', value: '150°', color: '#18181b' },
            { label: 'Recording Time', value: '3+ hours continuous', color: '#18181b' },
            { label: 'Storage', value: 'MicroSD card (required, not included)', color: '#18181b' }
          ]
        },
        {
          title: 'Battery & Connectivity',
          rows: [
            { label: 'Charging', value: 'USB-C, approx. 2 hours', color: '#18181b' },
            { label: 'Bluetooth', value: 'Bluetooth 5.4', color: '#18181b' },
            { label: 'Camera Recording Runtime', value: '3+ hours', color: '#18181b' },
            { label: 'Music Playback', value: 'Up to 40 hours', color: '#18181b' }
          ]
        }
      ].map(function (g, i) {
        var o = {};
        for (var k in g) o[k] = g[k];
        o.open = !!self.state.specOpen[i];
        o.chev = self.state.specOpen[i] ? 'rotate(180deg)' : 'rotate(0deg)';
        o.toggle = function () { self.setState(function (s) { var n = {}; for (var kk in s.specOpen) n[kk] = s.specOpen[kk]; n[i] = !s.specOpen[i]; return { specOpen: n }; }); };
        return o;
      }),
      audioFeatures: [
        'Built-in speakers for music & calls',
        'Built-in FM radio',
        'Rear turn signals + hazard mode',
        'Wireless handlebar remote included'
      ]
    };
    // add-on-waarden er los in (zoals ...this.renderAddons() in het origineel)
    for (var ak in addons) vals[ak] = addons[ak];
    return vals;
  };

  /* ---------- boot: alleen het actieve breakpoint mounten (perf-port #38) ----------
     De andere varianten worden pas gemount als het scherm van formaat verandert
     en hun media query actief wordt — 1x DOM/timers/beelden i.p.v. 3x. */
  var bootMounts = null;
  function adoptReviews() {
    if (window.RVH_REVIEWS && window.RVH_REVIEWS.length && REVIEWS !== window.RVH_REVIEWS) {
      REVIEWS = window.RVH_REVIEWS;
      if (bootMounts) for (var i = 0; i < bootMounts.length; i++) if (bootMounts[i].inst) bootMounts[i].inst.render();
      return true;
    }
    return !!REVIEWS.length;
  }
  function boot() {
    REVIEWS = window.RVH_REVIEWS || REVIEWS;
    var mounts = [
      { root: 'rvh-root-d', tpl: 'rvh-tpl-d', prefix: 'rvhd-', mq: '(min-width:1150px)', opts: { resetGalleryOnColor: true } },
      { root: 'rvh-root-t', tpl: 'rvh-tpl-t', prefix: 'rvht-', mq: '(min-width:768px) and (max-width:1149.98px)', opts: { resetGalleryOnColor: true } },
      { root: 'rvh-root-m', tpl: 'rvh-tpl-m', prefix: 'rvhm-', mq: '(max-width:767.98px)', opts: { resetGalleryOnColor: false } }
    ];
    function ensure(m) {
      if (m.inst) return;
      if (document.getElementById(m.root) && document.getElementById(m.tpl)) {
        m.inst = new RVH(m.root, m.tpl, m.prefix, m.opts);
        m.inst.mount();
      }
    }
    for (var i = 0; i < mounts.length; i++) {
      (function (m) {
        var mql = window.matchMedia ? window.matchMedia(m.mq) : null;
        if (!mql) { ensure(m); return; }
        if (mql.matches) ensure(m);
        var onChange = function (e) { if (e.matches) ensure(m); };
        if (mql.addEventListener) mql.addEventListener('change', onChange);
        else if (mql.addListener) mql.addListener(onChange);
      })(mounts[i]);
    }
    bootMounts = mounts;
    // vangnet: reviews-asset (defer) kan in documentvolgorde NA deze bundel
    // uitvoeren — zodra de data er is, reviews alsnog in beeld renderen
    if (!adoptReviews()) {
      window.addEventListener('load', adoptReviews);
      var tries = 0;
      var t = setInterval(function () {
        if (adoptReviews() || ++tries > 50) clearInterval(t);
      }, 200);
    }
  }
  // Deferred scripts draaien bij readyState 'interactive', vóór DOMContentLoaded;
  // pas bij DCL zijn ook de ándere deferred scripts (zoals de reviewdata) klaar.
  if (document.readyState === 'complete') boot();
  else document.addEventListener('DOMContentLoaded', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rly-home"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initHome(root) {
    // ---- Shop by category tabs ----
    var tabs = root.querySelectorAll('.rlyh-tab');
    var panels = root.querySelectorAll('.rlyh-panel');
    for (var i = 0; i < tabs.length; i++) {
      tabs[i].addEventListener('click', function () {
        var target = this.getAttribute('data-tab');
        for (var t = 0; t < tabs.length; t++) {
          var on = tabs[t] === this;
          tabs[t].classList.toggle('is-active', on);
          tabs[t].setAttribute('aria-selected', on ? 'true' : 'false');
        }
        for (var p = 0; p < panels.length; p++) {
          var show = panels[p].getAttribute('data-panel') === target;
          panels[p].classList.toggle('is-active', show);
          if (show) { panels[p].removeAttribute('hidden'); } else { panels[p].setAttribute('hidden', ''); }
        }
      });
    }

    // ---- Difference carousel dots (mobile) ----
    var track = root.querySelector('[data-diff-track]');
    var dotsWrap = root.querySelector('[data-diff-dots]');
    if (track && dotsWrap) {
      var dots = dotsWrap.querySelectorAll('.rlyh-dot');
      var step = 342; // card 330 + gap 12
      var raf = null;
      track.addEventListener('scroll', function () {
        if (raf) return;
        raf = requestAnimationFrame(function () {
          raf = null;
          var idx = Math.round(track.scrollLeft / step);
          if (idx < 0) idx = 0;
          if (idx > dots.length - 1) idx = dots.length - 1;
          for (var d = 0; d < dots.length; d++) dots[d].classList.toggle('is-active', d === idx);
        });
      });
      for (var k = 0; k < dots.length; k++) {
        (function (n) {
          dots[n].addEventListener('click', function () {
            track.scrollTo({ left: n * step, behavior: 'smooth' });
          });
        })(k);
      }
    }
  }

  function boot() {
    var roots = document.querySelectorAll('.rlyh');
    for (var i = 0; i < roots.length; i++) initHome(roots[i]);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rly-mobile-trustbar"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var track = document.querySelector('[data-rly-mtrust]');
    if (!track) return;
    var items = track.querySelectorAll('.rly-mtrust__item');
    if (items.length < 2) return;
    var i = 0;
    setInterval(function () {
      items[i].classList.remove('is-active');
      i = (i + 1) % items.length;
      items[i].classList.add('is-active');
    }, 3000);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rly-product-faq"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initSection(root) {
      if (!root || root.dataset.faqWired === '1') return;

      root.querySelectorAll('[data-faq-item]').forEach(function (item) {
        var q = item.querySelector('.rly-faq__q');
        if (!q) return;
        q.addEventListener('click', function () {
          var open = item.classList.toggle('is-open');
          q.setAttribute('aria-expanded', open ? 'true' : 'false');
        });
      });

      root.dataset.faqWired = '1';
    }

    document.querySelectorAll('.rly-faq').forEach(initSection);

    document.addEventListener('shopify:section:load', function (e) {
      var root = e.target && e.target.querySelector ? e.target.querySelector('.rly-faq') : null;
      if (root) initSection(root);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rly-product-ugc"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initSection(root) {
      if (!root || root.dataset.ugcWired === '1') return;

      var track = root.querySelector('[data-ugc-track]');
      var bar = root.querySelector('[data-ugc-scrollbar]');
      var thumb = root.querySelector('[data-ugc-thumb]');
      if (!track) return;

      function syncThumb() {
        if (!bar || !thumb) return;
        var max = track.scrollWidth - track.clientWidth;
        var ratio = max > 0 ? track.clientWidth / track.scrollWidth : 1;
        var barW = bar.clientWidth;
        var thumbW = Math.max(40, barW * ratio);
        thumb.style.width = thumbW + 'px';
        var pos = max > 0 ? (track.scrollLeft / max) * (barW - thumbW) : 0;
        thumb.style.left = pos + 'px';
      }

      track.addEventListener('scroll', syncThumb, { passive: true });
      window.addEventListener('resize', syncThumb);
      requestAnimationFrame(syncThumb);

      if (thumb && bar) {
        var dragging = false, startX = 0, startScroll = 0;

        function pos(e) { return (e.touches ? e.touches[0].clientX : e.clientX); }

        thumb.addEventListener('pointerdown', function (e) {
          dragging = true;
          startX = pos(e);
          startScroll = track.scrollLeft;
          thumb.setPointerCapture(e.pointerId);
          e.preventDefault();
        });

        thumb.addEventListener('pointermove', function (e) {
          if (!dragging) return;
          var barW = bar.clientWidth;
          var thumbW = thumb.clientWidth;
          var max = track.scrollWidth - track.clientWidth;
          var dx = pos(e) - startX;
          var trackPx = barW - thumbW;
          var scrollDx = trackPx > 0 ? (dx / trackPx) * max : 0;
          track.scrollLeft = startScroll + scrollDx;
        });

        function end(e) {
          if (!dragging) return;
          dragging = false;
          try { thumb.releasePointerCapture(e.pointerId); } catch (_) {}
        }
        thumb.addEventListener('pointerup', end);
        thumb.addEventListener('pointercancel', end);

        bar.addEventListener('pointerdown', function (e) {
          if (e.target === thumb) return;
          var rect = bar.getBoundingClientRect();
          var thumbW = thumb.clientWidth;
          var x = e.clientX - rect.left - thumbW / 2;
          var trackPx = rect.width - thumbW;
          var max = track.scrollWidth - track.clientWidth;
          var ratio = Math.max(0, Math.min(1, x / trackPx));
          track.scrollTo({ left: ratio * max, behavior: 'smooth' });
        });
      }

      root.dataset.ugcWired = '1';
    }

    document.querySelectorAll('.rly-ugc').forEach(initSection);

    document.addEventListener('shopify:section:load', function (e) {
      var root = e.target && e.target.querySelector ? e.target.querySelector('.rly-ugc') : null;
      if (root) initSection(root);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rly-product"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var MOBILE_MQ = '(max-width: 989px)';
    function isMobile() {
      return window.matchMedia(MOBILE_MQ).matches;
    }

    function initAccordion(root) {
      var allItems = Array.prototype.slice.call(root.querySelectorAll('[data-acc-item]'));
      allItems.forEach(function (item) {
        if (item.dataset.accWired === '1') return;
        var head = item.querySelector('.rly-pdp__acc-head');
        if (!head) return;
        head.addEventListener('click', function () {
          var willOpen = !item.classList.contains('is-open');
          // Single-open: sluit alle andere items eerst
          if (willOpen) {
            allItems.forEach(function (other) {
              if (other !== item && other.classList.contains('is-open')) {
                other.classList.remove('is-open');
                var otherHead = other.querySelector('.rly-pdp__acc-head');
                if (otherHead) otherHead.setAttribute('aria-expanded', 'false');
              }
            });
          }
          item.classList.toggle('is-open', willOpen);
          head.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
        });
        item.dataset.accWired = '1';
      });
    }

    function initGallery(root) {
      if (root.dataset.galleryWired === '1') return;

      var triggers = Array.prototype.slice.call(root.querySelectorAll('[data-lightbox-trigger]'));
      if (!triggers.length) return;

      var slides = triggers.map(function (t) {
        return {
          large: t.dataset.large,
          medium: t.dataset.medium || t.dataset.large,
          alt: t.dataset.alt || ''
        };
      });
      var current = 0;

      // ---------- Lightbox ----------
      var lightbox = root.querySelector('[data-lightbox]');
      var lbImg = lightbox && lightbox.querySelector('[data-lightbox-img]');
      var lbCounter = lightbox && lightbox.querySelector('[data-lightbox-counter]');
      var lbClose = lightbox && lightbox.querySelector('[data-lightbox-close]');
      var lbPrev = lightbox && lightbox.querySelector('[data-lightbox-prev]');
      var lbNext = lightbox && lightbox.querySelector('[data-lightbox-next]');
      var lastFocused = null;

      function showLightboxSlide(i) {
        current = (i + slides.length) % slides.length;
        if (lbImg) {
          lbImg.src = slides[current].large;
          lbImg.alt = slides[current].alt;
        }
        if (lbCounter) lbCounter.textContent = (current + 1) + ' / ' + slides.length;
        syncFeatured(current);
      }

      function openLightbox(i) {
        if (!lightbox) return;
        showLightboxSlide(i);
        lightbox.hidden = false;
        document.body.style.overflow = 'hidden';
        lastFocused = document.activeElement;
        if (lbClose) lbClose.focus();
      }

      function closeLightbox() {
        if (!lightbox) return;
        lightbox.hidden = true;
        document.body.style.overflow = '';
        if (lastFocused && lastFocused.focus) lastFocused.focus();
      }

      if (lbClose) lbClose.addEventListener('click', closeLightbox);
      if (lbPrev) lbPrev.addEventListener('click', function () { showLightboxSlide(current - 1); });
      if (lbNext) lbNext.addEventListener('click', function () { showLightboxSlide(current + 1); });
      if (lightbox) {
        lightbox.addEventListener('click', function (e) {
          if (e.target === lightbox) closeLightbox();
        });
      }
      document.addEventListener('keydown', function (e) {
        if (!lightbox || lightbox.hidden) return;
        if (e.key === 'Escape') closeLightbox();
        else if (e.key === 'ArrowLeft') showLightboxSlide(current - 1);
        else if (e.key === 'ArrowRight') showLightboxSlide(current + 1);
      });

      // ---------- Featured image (mobile) ----------
      var featured = root.querySelector('[data-featured-trigger]');
      var featuredImg = root.querySelector('[data-featured-img]');

      // Featured + lightbox USAPA-badge refs + "<img class="rly-pdp__strain-pill-ico" src="https://cdn.shopify.com/s/files/1/1016/6517/7894/files/Frame_2_2.png?v=1779528336" alt="" loading="lazy"><span>Recommended by Pickleball Coaches</span>" pill.
      // Beide alleen present op paddle-PDPs (tag-conditional in Liquid).
      // USAPA-badge: zichtbaar op image 0-2, hidden daarbuiten.
      // Strain pill: alleen op image 0 (eerste product image).
      var featuredBadge = root.querySelector('[data-featured-badge]');
      var lightboxBadge = root.querySelector('[data-lightbox-badge]');
      function toggleBadges(i) {
        var hide = i >= 3;
        if (featuredBadge) featuredBadge.classList.toggle('is-hidden', hide);
        if (lightboxBadge) lightboxBadge.classList.toggle('is-hidden', hide);
      }

      function syncFeatured(i) {
        if (!featuredImg) return;
        // BELANGRIJK: featuredImg heeft een srcset attribuut (uit Liquid render).
        // Wanneer srcset aanwezig is negeert de browser src en kiest uit srcset.
        // Op mobile (sizes="100vw") betekent dat de oude image blijft hangen
        // ondanks de nieuwe src. Daarom clearen we srcset bij elke swap zodat
        // de browser puur de nieuwe src laadt.
        featuredImg.removeAttribute('srcset');
        featuredImg.src = slides[i].medium;
        featuredImg.alt = slides[i].alt;
        triggers.forEach(function (t, idx) {
          t.classList.toggle('is-active', idx === i);
        });
        toggleBadges(i);
        // Scroll active thumbnail into view on mobile
        if (isMobile() && triggers[i] && triggers[i].scrollIntoView) {
          triggers[i].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
        }
      }

      function setFeatured(i) {
        current = (i + slides.length) % slides.length;
        syncFeatured(current);
      }

      // GEEN initiele syncFeatured(0): de Liquid-render toont image 0 al met
      // responsive srcset (width=800 op mobiel). syncFeatured verving de src
      // door de width=1200 variant en triggerde zo een tweede, late download
      // van het LCP-beeld (Lighthouse: LCP 3.0s -> 6.7s, 2026-06-05).
      // Active-state van thumb 0 staat al in de Liquid render; alleen de
      // badges hoeven een initiele state.
      toggleBadges(0);

      // Tile activatie — mobile en paddle-desktop swappen de featured image,
      // bag-desktop opent direct de lightbox (bag-PDPs hebben geen featured
      // image op desktop, alle media zit in een 2-col grid).
      // Paddle + Accessory PDPs delen dezelfde gallery-layout (featured +
       // thumbnail rail met click-to-swap). Beide krijgen daarom featured-swap
       // ipv direct lightbox openen op desktop.
      var isPaddleLayout = root.classList.contains('rly-pdp--paddle') || root.classList.contains('rly-pdp--accessory');
      triggers.forEach(function (t, i) {
        t.addEventListener('click', function () {
          if (isMobile() || isPaddleLayout) {
            setFeatured(i);
          } else {
            openLightbox(i);
          }
        });
      });

      // Featured click (mobile) → opens lightbox at current
      if (featured) {
        featured.addEventListener('click', function () {
          openLightbox(current);
        });
      }

      // Swipe on featured (mobile)
      if (featured) {
        var touchStartX = null;
        var touchStartY = null;
        featured.addEventListener('touchstart', function (e) {
          if (e.touches.length !== 1) return;
          touchStartX = e.touches[0].clientX;
          touchStartY = e.touches[0].clientY;
        }, { passive: true });
        featured.addEventListener('touchend', function (e) {
          if (touchStartX === null) return;
          var dx = e.changedTouches[0].clientX - touchStartX;
          var dy = e.changedTouches[0].clientY - touchStartY;
          touchStartX = null;
          touchStartY = null;
          // Horizontal swipe with minimum distance + dominant over vertical
          if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy)) {
            // Prevent tap-to-open-lightbox after a swipe
            featured.dataset.swiped = '1';
            setTimeout(function () { delete featured.dataset.swiped; }, 300);
            if (dx < 0) setFeatured(current + 1);
            else setFeatured(current - 1);
          }
        });
        featured.addEventListener('click', function (e) {
          if (featured.dataset.swiped === '1') {
            e.stopImmediatePropagation();
          }
        }, true);
      }

      // ---------- Rail arrows (mobile, when thumbnails overflow) ----------
      var rail = root.querySelector('[data-gallery-rail]');
      var btnRailPrev = root.querySelector('[data-rail-prev]');
      var btnRailNext = root.querySelector('[data-rail-next]');

      function updateArrows() {
        if (!rail) return;
        // Arrows zichtbaar bij overflow op mobile EN op paddle-desktop
        // (beide layouts hebben een horizontale thumb-rail).
        var canScroll = (isMobile() || isPaddleLayout) && rail.scrollWidth > rail.clientWidth + 4;
        if (btnRailPrev) btnRailPrev.hidden = !canScroll;
        if (btnRailNext) btnRailNext.hidden = !canScroll;
      }
      if (btnRailPrev && rail) btnRailPrev.addEventListener('click', function () {
        rail.scrollBy({ left: -rail.clientWidth * 0.8, behavior: 'smooth' });
      });
      if (btnRailNext && rail) btnRailNext.addEventListener('click', function () {
        rail.scrollBy({ left: rail.clientWidth * 0.8, behavior: 'smooth' });
      });
      window.addEventListener('resize', updateArrows);
      requestAnimationFrame(updateArrows);

      root.dataset.galleryWired = '1';
    }

    function initGiftZoom(root) {
      if (!root || root.dataset.giftZoomWired === '1') return;
      var trigger = root.querySelector('[data-gift-zoom-trigger]');
      var overlay = root.querySelector('[data-gift-zoom]');
      var img = overlay && overlay.querySelector('[data-gift-zoom-img]');
      var closeBtn = overlay && overlay.querySelector('[data-gift-zoom-close]');
      if (!trigger || !overlay || !img) return;

      // Port overlay naar document.body zodat position:fixed escape uit elke
      // ancestor stacking-context (transform/filter/contain op shopify-section
      // wrappers etc.). Anders bleek de overlay maar tot midden viewport te
      // strekken en lekken onderliggende secties (UGC, related) er doorheen.
      if (overlay.parentNode !== document.body) {
        document.body.appendChild(overlay);
      }

      function open(e) {
        if (e) { e.preventDefault(); e.stopPropagation(); }
        var large = trigger.getAttribute('data-large');
        if (large) img.setAttribute('src', large);
        overlay.hidden = false;
        document.body.style.overflow = 'hidden';
      }
      function close() {
        overlay.hidden = true;
        document.body.style.overflow = '';
      }

      trigger.addEventListener('click', open);
      if (closeBtn) closeBtn.addEventListener('click', close);
      overlay.addEventListener('click', function (e) {
        if (e.target === overlay) close();
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && !overlay.hidden) close();
      });

      root.dataset.giftZoomWired = '1';
    }

    /**
     * ATC loading-state: toont een spinner op de Add-to-cart button tijdens
     * de AJAX-add. Drawer-open laten we over aan Horizon's auto-open via
     * CartAddEvent — die fires PAS NA dat AJAX klaar is en de item in de
     * cart zit. Resultaat: klant ziet visual feedback op de button (spinner),
     * en wanneer de drawer slidet in is de tas ECHT al in de cart-list.
     * Geen empty-state-flicker meer.
     */
    function initAtcLoading(root) {
      if (!root || root.dataset.atcLoadingWired === '1') return;
      var atcBtn = root.querySelector('.rly-pdp__atc');
      if (!atcBtn) return;

      function setLoading(on) {
        atcBtn.classList.toggle('is-loading', on);
        atcBtn.setAttribute('aria-busy', on ? 'true' : 'false');
      }

      atcBtn.addEventListener('click', function () {
        if (atcBtn.disabled) return;
        // Vraag een frame later om het standaard click-flow niet te storen
        requestAnimationFrame(function () {
          setLoading(true);
        });
      });

      // Listen op CartAddEvent + CartErrorEvent vanuit Horizon's product-form-component.
      // CartAddEvent.eventName = ThemeEvents.cartUpdate = 'cart:update' (assets/events.js:115).
      // CartErrorEvent.eventName = 'cart:error'.
      document.addEventListener('cart:update', function () {
        setLoading(false);
      });
      document.addEventListener('cart:error', function () {
        setLoading(false);
      });
      // Safety: timeout van 8s zodat de button niet permanent loading-state
      // pakt als event-systeem hapert. 8s is meer dan genoeg voor zelfs
      // trage Shopify-stores.
      atcBtn.addEventListener('click', function () {
        setTimeout(function () { setLoading(false); }, 8000);
      });

      root.dataset.atcLoadingWired = '1';
    }

    // ---------- Edition selector (Standard / Plus) ----------
    // Twee aanklikbare opties boven de ATC. De gekozen optie zet de verborgen
    // variant-input (name="id") binnen het product-form + de getoonde prijs,
    // en klapt z'n eigen panel open terwijl de andere dichtklapt (CSS via
    // .is-selected). De mobiele sticky-ATC triggert dezelfde form, dus die
    // respecteert automatisch de gekozen editie.
    function initEdition(root) {
      var fs = root.querySelector('[data-rly-edition]');
      if (!fs || fs.dataset.editionWired === '1') return;
      var radios = Array.prototype.slice.call(fs.querySelectorAll('.rly-edition__radio'));
      if (!radios.length) return;
      var form = root.querySelector('product-form-component');
      var hiddenId = form ? form.querySelector('input[name="id"]') : root.querySelector('input[name="id"]');
      var priceNow = root.querySelector('.rly-pdp__price-now');

      function select(radio) {
        radios.forEach(function (r) {
          var opt = r.closest('[data-rly-opt]');
          var on = (r === radio);
          if (r.checked !== on) r.checked = on;
          if (opt) opt.classList.toggle('is-selected', on);
        });
        if (hiddenId && radio.dataset.variantId) {
          hiddenId.value = radio.dataset.variantId;
          hiddenId.dispatchEvent(new Event('change', { bubbles: true }));
          // Horizon's product-form leest de variant eerst uit ?variant= in de
          // URL en pas daarna uit de verborgen input. Sync de URL-param mee
          // zodat de juiste editie wordt toegevoegd, ook als er al een
          // ?variant= in de URL stond.
          try {
            var u = new URL(window.location.href);
            u.searchParams.set('variant', radio.dataset.variantId);
            window.history.replaceState({}, '', u);
          } catch (e) { /* no-op */ }
        }
        if (priceNow && radio.dataset.price) {
          priceNow.textContent = radio.dataset.price;
        }
      }

      fs.addEventListener('change', function (e) {
        var r = e.target && e.target.closest ? e.target.closest('.rly-edition__radio') : null;
        if (r) select(r);
      });

      // Hele optie-kaart klikbaar maken (niet alleen het label-rijtje), vooral op mobiel.
      // Klikken op een zoom-thumbnail wordt overgeslagen zodat die z'n eigen actie houdt.
      Array.prototype.slice.call(fs.querySelectorAll('[data-rly-opt]')).forEach(function (opt) {
        opt.addEventListener('click', function (e) {
          if (e.target && e.target.closest && e.target.closest('[data-rly-zoom]')) return;
          var r = opt.querySelector('.rly-edition__radio');
          if (r) select(r);
        });
      });

      var checked = null;
      for (var i = 0; i < radios.length; i++) {
        if (radios[i].checked) { checked = radios[i]; break; }
      }
      select(checked || radios[0]);

      fs.dataset.editionWired = '1';
    }

    function initEditionZoom(root) {
      if (!root || root.dataset.editionZoomWired === '1') return;
      var overlay = root.querySelector('[data-rly-edition-zoom]');
      var img = overlay && overlay.querySelector('[data-rly-edition-zoom-img]');
      var closeBtn = overlay && overlay.querySelector('[data-rly-edition-zoom-close]');
      if (!overlay || !img) return;
      if (overlay.parentNode !== document.body) document.body.appendChild(overlay);

      function close() {
        overlay.hidden = true;
        document.body.style.overflow = '';
      }
      root.addEventListener('click', function (e) {
        var t = e.target && e.target.closest ? e.target.closest('[data-rly-zoom]') : null;
        if (!t || !root.contains(t)) return;
        e.preventDefault();
        e.stopPropagation();
        var src = t.getAttribute('data-rly-zoom');
        if (!src) return;
        var thumbImg = t.querySelector('img');
        img.setAttribute('src', src);
        img.setAttribute('alt', thumbImg ? (thumbImg.getAttribute('alt') || '') : '');
        overlay.hidden = false;
        document.body.style.overflow = 'hidden';
      });
      if (closeBtn) closeBtn.addEventListener('click', close);
      overlay.addEventListener('click', function (e) { if (e.target === overlay) close(); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !overlay.hidden) close(); });

      root.dataset.editionZoomWired = '1';
    }

    function initSection(root) {
      if (!root) return;
      initAtcLoading(root);
      initAccordion(root);
      initGallery(root);
      initGiftZoom(root);
      initEdition(root);
      initEditionZoom(root);
    }

    document.querySelectorAll('.rly-pdp').forEach(initSection);

    document.addEventListener('shopify:section:load', function (e) {
      var root = e.target && e.target.querySelector ? e.target.querySelector('.rly-pdp') : null;
      if (root) initSection(root);
    });

    /* ---------- Click rating -> scroll to reviews section ---------- */
    if (!window.rlyReviewsScrollWired) {
      window.rlyReviewsScrollWired = true;

      function rlyFindReviews() {
        // Cards Carousel (new app block) gebruikt .jdgm-cards-carousel,
        // vintage widget gebruikt .jdgm-carousel-wrapper / .jdgm-rev-widg.
        // Probeer alle bekende varianten + losse fallbacks.
        var selectors = [
          '.jdgm-cards-carousel',
          '.jdgm-carousel-wrapper',
          '.jdgm-revs-cards',
          '.jdgm-rev-widg',
          '.jdgm-carousel',
          '.jdgm-widget',
          '.jm-review-item',
          '[id^="judgeme"]',
          '[class*="jdgm-cards"]',
          '[class*="judgeme"]'
        ];
        for (var i = 0; i < selectors.length; i++) {
          var el = document.querySelector(selectors[i]);
          if (el) return el;
        }
        return document.querySelector('[class*="jdgm"]');
      }

      document.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-scroll-reviews]');
        if (!btn) return;
        e.preventDefault();
        var jdgm = rlyFindReviews();
        if (!jdgm) {
          if (window.console) console.warn('Rally: reviews-section niet gevonden op de pagina (Judge.me-widget nog niet geladen?)');
          return;
        }
        var section = jdgm.closest('[id^="shopify-section-"]') || jdgm;
        // Sticky-header offset compensatie via scroll-margin
        var prevMargin = section.style.scrollMarginTop;
        section.style.scrollMarginTop = '90px';
        section.scrollIntoView({ behavior: 'smooth', block: 'start' });
        // Reset na de scroll zodat we andere flows niet beïnvloeden
        setTimeout(function () { section.style.scrollMarginTop = prevMargin; }, 1000);
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rly-radar-product"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-rrx-root]');
    if (!root) return;

    // ---- Gallery: desktop = vaste collage, mobiel = swipe-slider (Vision-
    // gedrag). Laadtechniek: op mobiel eerste 2 direct, daarna huidige + 2
    // vooruit bijladen bij het swipen; op desktop alles laden.
    var gallery = root.querySelector('[data-rrx-gallery]');
    if (gallery) {
      var gtrack = gallery.querySelector('[data-rrx-gtrack]');
      var gfill = gallery.querySelector('[data-rrx-gprogfill]');
      var gcount = gtrack ? gtrack.children.length : 0;
      var gidx = 0;
      var gmq = window.matchMedia('(max-width: 749px)');
      function gload(i) {
        if (i < 0 || i >= gcount || !gtrack) return;
        var sl = gtrack.children[i];
        if (!sl) return;
        var im = sl.querySelector('img[loading="lazy"]');
        if (im) { im.loading = 'eager'; }
      }
      function gprefetch() {
        if (!gmq.matches) { for (var i = 0; i < gcount; i++) gload(i); return; }
        gload(gidx); gload(gidx + 1); gload(gidx + 2);
      }
      var ghint = gallery.querySelector('[data-rrx-ghint]');
      function gset(i) {
        if (!gcount) return;
        gidx = (i + gcount) % gcount;
        if (ghint && gidx > 0) { ghint.remove(); ghint = null; }
        if (gtrack) gtrack.style.setProperty('--gx', (-gidx * 100) + '%');
        if (gfill) gfill.style.width = (((gidx + 1) / gcount) * 100) + '%';
        gprefetch();
      }
      var gsx = null;
      gallery.addEventListener('touchstart', function (e) { gsx = e.touches[0].clientX; }, { passive: true });
      gallery.addEventListener('touchend', function (e) {
        if (gsx === null || !gmq.matches) { gsx = null; return; }
        var dx = e.changedTouches[0].clientX - gsx;
        if (dx < -30) gset(gidx + 1); else if (dx > 30) gset(gidx - 1);
        gsx = null;
      });
      if (gmq.addEventListener) gmq.addEventListener('change', function () { gset(gidx); });
      gset(0);
    }

    // ---- Bundelkiezer: Single / Duo. Alle bedragen zijn server-side geformatteerd
    // (money-filters) en staan als data-attributen op de knoppen — JS wisselt alleen strings.
    var packs = root.querySelectorAll('[data-rrx-pack]');
    var variantInput = root.querySelector('[data-rrx-variant-id]');
    var priceEl = root.querySelector('[data-rrx-price]');
    var wasEl = root.querySelector('[data-rrx-was]');
    var saveEl = root.querySelector('[data-rrx-save]');
    var atcBtn = root.querySelector('.rrx__atc');
    function rrxSetAtcLabel(txt) {
      if (!atcBtn) return;
      var le = atcBtn.querySelector('.rrx__atc-label');
      if (le) { le.textContent = txt; } else { atcBtn.textContent = txt; }
    }
    var stickyBtn = root.querySelector('[data-rrx-sticky-trigger]');
    var stickyPrice = root.querySelector('[data-rrx-sticky-price]');
    var stickyWas = root.querySelector('[data-rrx-sticky-was]');

    function applyPack(pk) {
      for (var s = 0; s < packs.length; s++) packs[s].classList.toggle('is-on', packs[s] === pk);
      var vid = pk.getAttribute('data-variant-id');
      if (variantInput && vid) {
        variantInput.value = vid;
        variantInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
      var pTxt = pk.getAttribute('data-price');
      if (priceEl && pTxt) priceEl.textContent = pTxt;
      if (stickyPrice && pTxt) stickyPrice.textContent = pTxt;
      var wasTxt = pk.getAttribute('data-was') || '';
      if (wasEl) { wasEl.textContent = wasTxt; wasEl.hidden = !wasTxt; }
      if (stickyWas) { stickyWas.textContent = wasTxt; stickyWas.hidden = !wasTxt; }
      var saveTxt = pk.getAttribute('data-save') || '';
      if (saveEl) { saveEl.textContent = saveTxt; saveEl.hidden = !saveTxt; }
      var label = pk.getAttribute('data-label');
      if (label) {
        label = label.replace('&mdash;', '—');
        // Horizon's add-to-cart-component vervangt de inner span na de eerste
        // render — daarom RV-stijl fallback op de knop zelf (zelfde patroon
        // als updateAtcTotal in de Vision-sectie).
        if (atcBtn && !atcBtn.disabled) rrxSetAtcLabel(label);
        if (stickyBtn && !stickyBtn.disabled) stickyBtn.textContent = label;
      }
      try { var url = new URL(window.location.href); url.searchParams.set('variant', vid); history.replaceState({}, '', url.toString()); } catch (e) {}
    }
    for (var i = 0; i < packs.length; i++) {
      (function (pk) { pk.addEventListener('click', function () { applyPack(pk); }); })(packs[i]);
    }

    // ---- Mini review carousel (buy box) ----
    var miniq = root.querySelector('[data-rrx-miniq]');
    if (miniq) {
      var qData = [
        { n: 'Doug M.', t: 'No app, no pairing, no bike computer needed. Charged it, clicked it on my seatpost and it caught the first car that came up behind me. My wife wants one for her bike now.' },
        { n: 'Russell T.', t: 'I was skeptical a $79 radar could actually work. It beeped before I heard the car behind me. I have stopped looking over my shoulder.' },
        { n: 'Rachel T.', t: 'Took me a minute to get the angle right on my aero post, the saddle rail mount did the trick. It picks up the cars coming up behind us on my Saturday group ride and stays quiet for the riders on my wheel.' }
      ];
      var qi = 0;
      var qText = miniq.querySelector('[data-rrx-qtext]');
      var qName = miniq.querySelector('[data-rrx-qname]');
      var qAv = miniq.querySelector('[data-rrx-qav]');
      var qDots = miniq.querySelectorAll('[data-rrx-qdot]');
      function setQ(i) {
        qi = (i + qData.length) % qData.length;
        if (qText) qText.textContent = qData[qi].t;
        if (qName) qName.textContent = qData[qi].n;
        if (qAv) { var a = miniq.getAttribute('data-av' + qi); if (a) qAv.src = a; }
        for (var d = 0; d < qDots.length; d++) qDots[d].classList.toggle('is-on', d === qi);
      }
      var qPrev = miniq.querySelector('[data-rrx-qprev]');
      var qNext = miniq.querySelector('[data-rrx-qnext]');
      if (qPrev) qPrev.addEventListener('click', function () { setQ(qi - 1); });
      if (qNext) qNext.addEventListener('click', function () { setQ(qi + 1); });
      for (var d2 = 0; d2 < qDots.length; d2++) {
        (function (idx) { qDots[idx].addEventListener('click', function () { setQ(idx); }); })(d2);
      }
      var qx = null;
      miniq.addEventListener('touchstart', function (e) { qx = e.touches[0].clientX; }, { passive: true });
      miniq.addEventListener('touchend', function (e) {
        if (qx === null) return;
        var dx = e.changedTouches[0].clientX - qx;
        if (dx < -30) setQ(qi + 1); else if (dx > 30) setQ(qi - 1);
        qx = null;
      });
    }

    // ---- Gratis voorlamp: PDP-toggle (zelfde werking als de Vision-powerbank).
    // Stand leeft als cart-attribute rly_no_frontlight; motor + drawer syncen mee.
    var giftCard = root.querySelector('[data-rrx-gift]');
    function giftIsOn() { return !(giftCard && giftCard.classList.contains('is-off')); }
    function syncGiftCard(off) {
      if (!giftCard) return;
      giftCard.classList.toggle('is-off', !!off);
      giftCard.setAttribute('aria-pressed', off ? 'false' : 'true');
    }
    if (giftCard) {
      var toggleGift = function () {
        giftCard.classList.toggle('is-off');
        var off = giftCard.classList.contains('is-off');
        giftCard.setAttribute('aria-pressed', off ? 'false' : 'true');
        fetch('/cart/update.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ attributes: { rly_no_frontlight: off ? 'true' : '' }, sections: rrxSectionIds().join(','), sections_url: window.location.pathname })
        }).then(function (r) { return r.json(); }).then(function (resp) {
          rrxDispatchCartUpdate(resp, resp.sections || {}, 'rrx-gift-toggle');
        }).catch(function () {});
      };
      giftCard.addEventListener('click', toggleGift);
      giftCard.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); toggleGift(); }
      });
      fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          if (cart && cart.attributes) syncGiftCard(!!cart.attributes.rly_no_frontlight);
        }).catch(function () {});
      document.addEventListener('cart:update', function (e) {
        var c = e && e.detail && e.detail.resource;
        if (!c || !c.attributes) return;
        var src = (e.detail.data && e.detail.data.source) || '';
        if (src !== 'rrx-gift-toggle') syncGiftCard(!!c.attributes.rly_no_frontlight);
      });
    }

    // ---- ADD TO CART: één call — gekozen variant + (indien aan) de gratis voorlamp.
    // Knop is [data-rrx-owned]: rly-auto-gift.js en Horizon blijven er vanaf.
    function rrxSectionIds() {
      var ids = [];
      var nodes = document.querySelectorAll('cart-items-component[data-section-id], cart-icon[data-section-id]');
      for (var i = 0; i < nodes.length; i++) {
        var sid = nodes[i].getAttribute('data-section-id');
        if (sid && ids.indexOf(sid) === -1) ids.push(sid);
      }
      return ids;
    }
    function rrxSkeleton(show) {
      document.body.classList.toggle('rly-cart-skeleton-active', !!show);
      var sk = document.querySelector('.rly-cart-skeleton');
      if (sk) { if (show) sk.removeAttribute('hidden'); else sk.setAttribute('hidden', ''); }
    }
    function rrxOpenDrawer() {
      var cd = document.querySelector('cart-drawer-component');
      if (!cd) return;
      if (typeof cd.open === 'function') cd.open();
      else if (typeof cd.showDialog === 'function') cd.showDialog();
    }
    function rrxVisibleCount(cart) {
      if (!cart || !cart.items) return 0;
      var n = 0;
      for (var i = 0; i < cart.items.length; i++) {
        var it = cart.items[i];
        var isGift = it.properties && (it.properties._gift === 'true' || it.properties._gift === true);
        if (!isGift) n += it.quantity || 0;
      }
      return n;
    }
    function rrxDispatchCartUpdate(cart, sections, source) {
      try {
        document.dispatchEvent(new CustomEvent('cart:update', {
          bubbles: true,
          detail: {
            resource: cart,
            sourceId: source || 'rly-radar-atc',
            data: { source: source || 'rly-radar-atc', sections: sections || {}, itemCount: rrxVisibleCount(cart) }
          }
        }));
      } catch (err) { /* event-dispatch mag nooit de add blokkeren */ }
    }

    var atcBusy = false;
    function rrxAddToCart() {
      if (atcBusy || !atcBtn || atcBtn.disabled) return;
      var vid = variantInput ? Number(variantInput.value) : 0;
      if (!vid) return;
      atcBusy = true;
      var prevLabel = atcBtn.textContent.trim();
      rrxSetAtcLabel('Adding…');
      atcBtn.style.opacity = '0.75';

      var flVid = atcBtn.getAttribute('data-rrx-fl-vid');
      var items = [{ id: vid, quantity: 1 }];
      if (giftIsOn() && flVid) items.push({ id: Number(flVid), quantity: 1, properties: { _gift: 'true' } });

      rrxSkeleton(true);
      rrxOpenDrawer();

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items, sections: rrxSectionIds().join(','), sections_url: window.location.pathname })
      })
        .then(function (r) { return r.json().then(function (json) { return { ok: r.ok, json: json }; }); })
        .then(function (res) {
          if (!res.ok || res.json.status) {
            throw new Error((res.json && (res.json.description || res.json.message)) || 'add failed');
          }
          return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
            .then(function (r) { return r.json(); })
            .catch(function () { return null; })
            .then(function (cart) {
              rrxDispatchCartUpdate(cart, res.json.sections || {});
              rrxSkeleton(false);
              rrxSetAtcLabel(prevLabel);
              atcBtn.style.opacity = '';
            });
        })
        .catch(function () {
          rrxSkeleton(false);
          rrxSetAtcLabel('Something went wrong — try again');
          setTimeout(function () { rrxSetAtcLabel(prevLabel); }, 2500);
          atcBtn.style.opacity = '';
        })
        .then(function () { atcBusy = false; });
    }

    if (atcBtn) {
      atcBtn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        rrxAddToCart();
      });
    }

    // ---- Buy it now: variant toevoegen en direct naar checkout ----
    var buynow = root.querySelector('[data-rrx-buynow]');
    if (buynow) {
      buynow.addEventListener('click', function () {
        var vid = variantInput ? variantInput.value : null;
        if (!vid) return;
        buynow.disabled = true;
        var flVid2 = atcBtn ? atcBtn.getAttribute('data-rrx-fl-vid') : '';
        var bnItems = [{ id: Number(vid), quantity: 1 }];
        if (giftIsOn() && flVid2) bnItems.push({ id: Number(flVid2), quantity: 1, properties: { _gift: 'true' } });
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: bnItems })
        }).then(function (r) {
          if (!r.ok) throw new Error('add failed');
          window.location.href = '/checkout';
        }).catch(function () {
          buynow.disabled = false;
          var prevTxt = buynow.textContent;
          buynow.textContent = 'Something went wrong — try again';
          setTimeout(function () { buynow.textContent = prevTxt; }, 2500);
        });
      });
    }

    // ---- Sticky ATC: pas tonen als ATC + Buy now boven de viewport uit beeld zijn ----
    var stickyBar = root.querySelector('[data-rrx-sticky]');
    if (stickyBar && atcBtn && stickyBtn) {
      stickyBtn.addEventListener('click', function () { atcBtn.click(); });
    }
    var stickyAnchor = root.querySelector('.rrx__buynow') || atcBtn;
    if (stickyBar && stickyAnchor && 'IntersectionObserver' in window) {
      var sio = new IntersectionObserver(function (entries) {
        var en = entries[0];
        var past = !en.isIntersecting && en.boundingClientRect.top < 0;
        stickyBar.classList.toggle('is-visible', past);
      }, { threshold: 0 });
      sio.observe(stickyAnchor);
    } else if (stickyBar) {
      stickyBar.classList.add('is-visible');
    }

    // ---- Reviews: paginering, 5 per pagina (pagina's 2+ laden uit hun <template>) ----
    var revPagesWrap = root.querySelector('[data-rrx-revpages]');
    var revPager = root.querySelector('[data-rrx-revpager]');
    if (revPagesWrap && revPager) {
      var revTotal = parseInt(revPagesWrap.getAttribute('data-rrx-revcount'), 10) || 1;
      var revCur = 1;
      var revSec = revPagesWrap.closest('.rrx__reviews');
      function revMaterialize(n) {
        var pg = revPagesWrap.querySelector('[data-rrx-revpage="' + n + '"]');
        if (pg) return pg;
        var tpl = revPagesWrap.querySelector('template[data-rrx-revtpl="' + n + '"]');
        if (!tpl) return null;
        tpl.parentNode.insertBefore(tpl.content.cloneNode(true), tpl);
        tpl.parentNode.removeChild(tpl);
        return revPagesWrap.querySelector('[data-rrx-revpage="' + n + '"]');
      }
      function revBtn(label, page, opts) {
        opts = opts || {};
        var b = document.createElement('button');
        b.type = 'button';
        b.textContent = label;
        if (opts.on) b.className = 'is-on';
        if (opts.disabled) b.disabled = true;
        if (opts.aria) b.setAttribute('aria-label', opts.aria);
        if (page) b.addEventListener('click', function () { revGo(page); });
        return b;
      }
      function revRender() {
        var pages = revPagesWrap.querySelectorAll('[data-rrx-revpage]');
        for (var i = 0; i < pages.length; i++) { pages[i].hidden = pages[i].getAttribute('data-rrx-revpage') !== String(revCur); }
        revPager.innerHTML = '';
        revPager.appendChild(revBtn('\u2039', revCur > 1 ? revCur - 1 : null, { disabled: revCur === 1, aria: 'Previous page' }));
        var start = Math.min(Math.max(revCur - 1, 1), Math.max(revTotal - 2, 1));
        for (var p = start; p < start + 3 && p <= revTotal; p++) {
          revPager.appendChild(revBtn(String(p), p, { on: p === revCur }));
        }
        revPager.appendChild(revBtn('\u203a', revCur < revTotal ? revCur + 1 : null, { disabled: revCur === revTotal, aria: 'Next page' }));
      }
      function revGo(n) {
        revMaterialize(n);
        revCur = n;
        revRender();
        if (revSec) { var y = revSec.getBoundingClientRect().top + window.pageYOffset - 80; window.scrollTo({ top: y, behavior: 'smooth' }); }
      }
      revRender();
    }

    // ---- Review-foto lightbox: klik op een foto opent hem groot ----
    var imgModal = root.querySelector('[data-rrx-imgmodal]');
    var imgTarget = imgModal ? imgModal.querySelector('[data-rrx-imgtarget]') : null;
    function openImg(src, alt) {
      if (imgModal && imgTarget && src) {
        imgTarget.src = src;
        imgTarget.alt = alt || '';
        imgModal.hidden = false;
        document.body.style.overflow = 'hidden';
      }
    }
    function closeImg() {
      if (!imgModal) return;
      imgModal.hidden = true;
      document.body.style.overflow = '';
      if (imgTarget) imgTarget.removeAttribute('src');
    }
    root.addEventListener('click', function (e) {
      var ph = e.target.closest ? e.target.closest('[data-rrx-revphoto]') : null;
      if (!ph) return;
      var im = ph.querySelector('img') || ph;
      openImg(im.getAttribute('data-full') || im.getAttribute('src'), im.getAttribute('alt'));
    });
    var closers = root.querySelectorAll('[data-rrx-imgclose]');
    for (var ic = 0; ic < closers.length; ic++) closers[ic].addEventListener('click', closeImg);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeImg(); });

    // ---- Final CTA: terug naar boven (buy box) ----
    var toTop = root.querySelector('[data-rrx-totop]');
    if (toTop) {
      toTop.addEventListener('click', function () {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });
    }

  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rly-video-row"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-rly-vr-play]');
    if (!btn) return;
    var media = btn.closest('.rly-vr__media');
    var video = media && media.querySelector('[data-rly-vr-video]');
    if (!video) return;
    video.setAttribute('controls', '');
    btn.style.display = 'none';
    var p = video.play();
    if (p && p.catch) { p.catch(function () {}); }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rly-vision-product"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var MOBILE_MQ = '(max-width: 989px)';
    function isMobile() {
      return window.matchMedia(MOBILE_MQ).matches;
    }

    function initAccordion(root) {
      var allItems = Array.prototype.slice.call(root.querySelectorAll('[data-acc-item]'));
      allItems.forEach(function (item) {
        if (item.dataset.accWired === '1') return;
        var head = item.querySelector('.rly-pdp__acc-head');
        if (!head) return;
        head.addEventListener('click', function () {
          var willOpen = !item.classList.contains('is-open');
          // Single-open: sluit alle andere items eerst
          if (willOpen) {
            allItems.forEach(function (other) {
              if (other !== item && other.classList.contains('is-open')) {
                other.classList.remove('is-open');
                var otherHead = other.querySelector('.rly-pdp__acc-head');
                if (otherHead) otherHead.setAttribute('aria-expanded', 'false');
              }
            });
          }
          item.classList.toggle('is-open', willOpen);
          head.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
        });
        item.dataset.accWired = '1';
      });
    }

    function initGallery(root) {
      if (root.dataset.galleryWired === '1') return;

      var triggers = Array.prototype.slice.call(root.querySelectorAll('[data-lightbox-trigger]'));
      if (!triggers.length) return;

      var slides = triggers.map(function (t) {
        return {
          large: t.dataset.large,
          medium: t.dataset.medium || t.dataset.large,
          small: t.dataset.small || t.dataset.medium || t.dataset.large,
          alt: t.dataset.alt || ''
        };
      });
      var current = 0;

      // Kies de bron op schermmaat: 800px op mobiel is ruim genoeg voor de
      // featured-breedte, 1200px op desktop. Scheelt data per swipe.
      function srcForSlide(s) {
        return isMobile() ? s.small : s.medium;
      }
      // Preload-cache zodat een buurfoto maar één keer wordt opgehaald.
      var preloaded = {};
      function preload(url) {
        if (!url || preloaded[url]) return;
        preloaded[url] = new Image();
        preloaded[url].src = url;
      }
      // Laad de 2 buren aan beide kanten van de zichtbare set stil vooruit,
      // zodat ze al in de browsercache staan voordat er geswipet wordt.
      function preloadNeighbors(i) {
        [ -1, 1 ].forEach(function (dir) {
          var idx = i;
          for (var n = 0; n < 2; n++) {
            idx = stepVisibleBounded(idx, dir);
            if (idx === -1) break;
            preload(srcForSlide(slides[idx]));
          }
        });
      }

      // Vision-kleurfilter verbergt thumbs van niet-gekozen kleuren.
      // Swipe en lightbox-pijlen moeten die overslaan, anders toon je
      // bv. een zwarte bril terwijl de orange swatch aan staat.
      function isTriggerVisible(t) {
        var w = t.closest('.rly-pdp__media') || t;
        return w.style.display !== 'none';
      }
      function stepVisible(from, dir) {
        var len = triggers.length;
        for (var n = 1; n <= len; n++) {
          var idx = (((from + dir * n) % len) + len) % len;
          if (isTriggerVisible(triggers[idx])) return idx;
        }
        return from;
      }
      // Niet-loopende variant voor de stage-slider (operator-verzoek
      // 2026-06-12): van de eerste afbeelding kun je niet "linksom" naar
      // de laatste. Geeft -1 als er in die richting niets meer is.
      // De lightbox blijft de loopende stepVisible gebruiken.
      function stepVisibleBounded(from, dir) {
        for (var idx = from + dir; idx >= 0 && idx < triggers.length; idx += dir) {
          if (isTriggerVisible(triggers[idx])) return idx;
        }
        return -1;
      }

      // ---------- Lightbox ----------
      var lightbox = root.querySelector('[data-lightbox]');
      var lbImg = lightbox && lightbox.querySelector('[data-lightbox-img]');
      var lbCounter = lightbox && lightbox.querySelector('[data-lightbox-counter]');
      var lbClose = lightbox && lightbox.querySelector('[data-lightbox-close]');
      var lbPrev = lightbox && lightbox.querySelector('[data-lightbox-prev]');
      var lbNext = lightbox && lightbox.querySelector('[data-lightbox-next]');
      var lastFocused = null;

      function showLightboxSlide(i) {
        current = (i + slides.length) % slides.length;
        if (lbImg) {
          lbImg.src = slides[current].large;
          lbImg.alt = slides[current].alt;
        }
        if (lbCounter) lbCounter.textContent = (current + 1) + ' / ' + slides.length;
        syncFeatured(current);
      }

      function openLightbox(i) {
        if (!lightbox) return;
        showLightboxSlide(i);
        lightbox.hidden = false;
        document.body.style.overflow = 'hidden';
        lastFocused = document.activeElement;
        if (lbClose) lbClose.focus();
      }

      function closeLightbox() {
        if (!lightbox) return;
        lightbox.hidden = true;
        document.body.style.overflow = '';
        if (lastFocused && lastFocused.focus) lastFocused.focus();
      }

      if (lbClose) lbClose.addEventListener('click', closeLightbox);
      if (lbPrev) lbPrev.addEventListener('click', function () { showLightboxSlide(stepVisible(current, -1)); });
      if (lbNext) lbNext.addEventListener('click', function () { showLightboxSlide(stepVisible(current, 1)); });
      if (lightbox) {
        lightbox.addEventListener('click', function (e) {
          if (e.target === lightbox) closeLightbox();
        });
      }
      document.addEventListener('keydown', function (e) {
        if (!lightbox || lightbox.hidden) return;
        if (e.key === 'Escape') closeLightbox();
        else if (e.key === 'ArrowLeft') showLightboxSlide(stepVisible(current, -1));
        else if (e.key === 'ArrowRight') showLightboxSlide(stepVisible(current, 1));
      });

      // ---------- Featured image (mobile) ----------
      var featured = root.querySelector('[data-featured-trigger]');
      var featuredImg = root.querySelector('[data-featured-img]');

      // Featured + lightbox badge refs (placeholder badges, operator vult later in).
      // Badges: zichtbaar op image 0-2, hidden daarbuiten.
      var featuredBadge = root.querySelector('[data-featured-badge]');
      var lightboxBadge = root.querySelector('[data-lightbox-badge]');
      function toggleBadges(i) {
        var hide = i >= 3;
        if (featuredBadge) featuredBadge.classList.toggle('is-hidden', hide);
        if (lightboxBadge) lightboxBadge.classList.toggle('is-hidden', hide);
      }

      function syncFeatured(i) {
        if (!featuredImg) return;
        // BELANGRIJK: featuredImg heeft een srcset attribuut (uit Liquid render).
        // Wanneer srcset aanwezig is negeert de browser src en kiest uit srcset.
        // Op mobile (sizes="100vw") betekent dat de oude image blijft hangen
        // ondanks de nieuwe src. Daarom clearen we srcset bij elke swap zodat
        // de browser puur de nieuwe src laadt.
        featuredImg.removeAttribute('srcset');
        featuredImg.src = srcForSlide(slides[i]);
        featuredImg.alt = slides[i].alt;
        triggers.forEach(function (t, idx) {
          t.classList.toggle('is-active', idx === i);
        });
        toggleBadges(i);
        // Buren alvast in de cache zetten voor een snappy swipe.
        preloadNeighbors(i);
        // Scroll active thumbnail into view on mobile
        if (isMobile() && triggers[i] && triggers[i].scrollIntoView) {
          triggers[i].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
        }
        // Dots-navigatie (Vision) luistert hierop en hertekent zichzelf.
        root.dispatchEvent(new CustomEvent('vision:featured-change'));
      }

      function setFeatured(i) {
        current = (i + slides.length) % slides.length;
        syncFeatured(current);
      }

      // GEEN initiele syncFeatured(0): de Liquid-render toont image 0 al met
      // responsive srcset (width=800 op mobiel). syncFeatured verving de src
      // door de width=1200 variant en triggerde zo een tweede, late download
      // van het LCP-beeld (Lighthouse: LCP 3.0s -> 6.7s, 2026-06-05).
      // Active-state van thumb 0 staat al in de Liquid render; alleen de
      // badges hoeven een initiele state.
      toggleBadges(0);
      // Buren van de eerste foto vast vooruit laden zodat de eerste swipe
      // al snel is. STRIKT na het page-load-event, en dan nog in idle-tijd,
      // zodat het nooit met de eerste weergave (LCP) concurreert.
      function preloadFirstNeighbors() {
        if ('requestIdleCallback' in window) {
          requestIdleCallback(function () { preloadNeighbors(0); });
        } else {
          setTimeout(function () { preloadNeighbors(0); }, 200);
        }
      }
      if (document.readyState === 'complete') {
        preloadFirstNeighbors();
      } else {
        window.addEventListener('load', preloadFirstNeighbors);
      }

      // Tile activatie — mobile en paddle-desktop swappen de featured image,
      // bag-desktop opent direct de lightbox (bag-PDPs hebben geen featured
      // image op desktop, alle media zit in een 2-col grid).
      // Paddle + Accessory PDPs delen dezelfde gallery-layout (featured +
       // thumbnail rail met click-to-swap). Beide krijgen daarom featured-swap
       // ipv direct lightbox openen op desktop.
      var isPaddleLayout = root.classList.contains('rly-pdp--paddle') || root.classList.contains('rly-pdp--accessory');
      triggers.forEach(function (t, i) {
        t.addEventListener('click', function () {
          if (isMobile() || isPaddleLayout) {
            setFeatured(i);
          } else {
            openLightbox(i);
          }
        });
      });

      // Featured click (mobile) → opens lightbox at current
      if (featured) {
        featured.addEventListener('click', function () {
          openLightbox(current);
        });
      }

      // Swipe on featured (mobile)
      if (featured) {
        var touchStartX = null;
        var touchStartY = null;
        featured.addEventListener('touchstart', function (e) {
          if (e.touches.length !== 1) return;
          touchStartX = e.touches[0].clientX;
          touchStartY = e.touches[0].clientY;
        }, { passive: true });
        featured.addEventListener('touchend', function (e) {
          if (touchStartX === null) return;
          var dx = e.changedTouches[0].clientX - touchStartX;
          var dy = e.changedTouches[0].clientY - touchStartY;
          touchStartX = null;
          touchStartY = null;
          // Horizontal swipe with minimum distance + dominant over vertical
          if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy)) {
            // Prevent tap-to-open-lightbox after a swipe
            featured.dataset.swiped = '1';
            setTimeout(function () { delete featured.dataset.swiped; }, 300);
            var swTarget = stepVisibleBounded(current, dx < 0 ? 1 : -1);
            if (swTarget !== -1) setFeatured(swTarget);
          }
        });
        featured.addEventListener('click', function (e) {
          if (featured.dataset.swiped === '1') {
            e.stopImmediatePropagation();
          }
        }, true);

        // Muis-drag op desktop (Vision): zelfde gedrag als touch-swipe.
        // pointerType-check zodat touch niet dubbel triggert.
        var mouseStartX = null;
        featured.addEventListener('pointerdown', function (e) {
          if (e.pointerType !== 'mouse') return;
          mouseStartX = e.clientX;
        });
        featured.addEventListener('pointerup', function (e) {
          if (e.pointerType !== 'mouse' || mouseStartX === null) return;
          var dx = e.clientX - mouseStartX;
          mouseStartX = null;
          if (Math.abs(dx) > 50) {
            featured.dataset.swiped = '1';
            setTimeout(function () { delete featured.dataset.swiped; }, 300);
            var dragTarget = stepVisibleBounded(current, dx < 0 ? 1 : -1);
            if (dragTarget !== -1) setFeatured(dragTarget);
          }
        });
      }

      // ---------- Stage-pijlen (Vision): klik links/rechts op de featured ----------
      // Niet-loopend: aan de uiteinden wordt de pijl verborgen.
      var stagePrev = root.querySelector('[data-stage-prev]');
      var stageNext = root.querySelector('[data-stage-next]');
      function updateStageArrows() {
        if (stagePrev) stagePrev.hidden = stepVisibleBounded(current, -1) === -1;
        if (stageNext) stageNext.hidden = stepVisibleBounded(current, 1) === -1;
      }
      if (stagePrev) stagePrev.addEventListener('click', function () {
        var i = stepVisibleBounded(current, -1);
        if (i !== -1) setFeatured(i);
      });
      if (stageNext) stageNext.addEventListener('click', function () {
        var i = stepVisibleBounded(current, 1);
        if (i !== -1) setFeatured(i);
      });
      updateStageArrows();
      root.addEventListener('vision:featured-change', updateStageArrows);

      // ---------- Rail arrows (mobile, when thumbnails overflow) ----------
      var rail = root.querySelector('[data-gallery-rail]');
      var btnRailPrev = root.querySelector('[data-rail-prev]');
      var btnRailNext = root.querySelector('[data-rail-next]');

      function updateArrows() {
        if (!rail) return;
        // Arrows zichtbaar bij overflow op mobile EN op paddle-desktop
        // (beide layouts hebben een horizontale thumb-rail).
        var canScroll = (isMobile() || isPaddleLayout) && rail.scrollWidth > rail.clientWidth + 4;
        if (btnRailPrev) btnRailPrev.hidden = !canScroll;
        if (btnRailNext) btnRailNext.hidden = !canScroll;
      }
      if (btnRailPrev && rail) btnRailPrev.addEventListener('click', function () {
        rail.scrollBy({ left: -rail.clientWidth * 0.8, behavior: 'smooth' });
      });
      if (btnRailNext && rail) btnRailNext.addEventListener('click', function () {
        rail.scrollBy({ left: rail.clientWidth * 0.8, behavior: 'smooth' });
      });
      window.addEventListener('resize', updateArrows);
      requestAnimationFrame(updateArrows);

      root.dataset.galleryWired = '1';
    }

    function initGiftZoom(root) {
      if (!root || root.dataset.giftZoomWired === '1') return;
      var trigger = root.querySelector('[data-gift-zoom-trigger]');
      var overlay = root.querySelector('[data-gift-zoom]');
      var img = overlay && overlay.querySelector('[data-gift-zoom-img]');
      var closeBtn = overlay && overlay.querySelector('[data-gift-zoom-close]');
      if (!trigger || !overlay || !img) return;

      // Port overlay naar document.body zodat position:fixed escape uit elke
      // ancestor stacking-context (transform/filter/contain op shopify-section
      // wrappers etc.). Anders bleek de overlay maar tot midden viewport te
      // strekken en lekken onderliggende secties (UGC, related) er doorheen.
      if (overlay.parentNode !== document.body) {
        document.body.appendChild(overlay);
      }

      function open(e) {
        if (e) { e.preventDefault(); e.stopPropagation(); }
        var large = trigger.getAttribute('data-large');
        if (large) img.setAttribute('src', large);
        overlay.hidden = false;
        document.body.style.overflow = 'hidden';
      }
      function close() {
        overlay.hidden = true;
        document.body.style.overflow = '';
      }

      trigger.addEventListener('click', open);
      if (closeBtn) closeBtn.addEventListener('click', close);
      overlay.addEventListener('click', function (e) {
        if (e.target === overlay) close();
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && !overlay.hidden) close();
      });

      root.dataset.giftZoomWired = '1';
    }

    /**
     * ATC loading-state: toont een spinner op de Add-to-cart button tijdens
     * de AJAX-add. Drawer-open laten we over aan Horizon's auto-open via
     * CartAddEvent — die fires PAS NA dat AJAX klaar is en de item in de
     * cart zit. Resultaat: klant ziet visual feedback op de button (spinner),
     * en wanneer de drawer slidet in is de tas ECHT al in de cart-list.
     * Geen empty-state-flicker meer.
     */
    function initAtcLoading(root) {
      if (!root || root.dataset.atcLoadingWired === '1') return;
      var atcBtn = root.querySelector('.rly-pdp__atc');
      if (!atcBtn) return;

      function setLoading(on) {
        atcBtn.classList.toggle('is-loading', on);
        atcBtn.setAttribute('aria-busy', on ? 'true' : 'false');
      }

      atcBtn.addEventListener('click', function () {
        if (atcBtn.disabled) return;
        // Vraag een frame later om het standaard click-flow niet te storen
        requestAnimationFrame(function () {
          setLoading(true);
        });
      });

      // Listen op CartAddEvent + CartErrorEvent vanuit Horizon's product-form-component.
      // CartAddEvent.eventName = ThemeEvents.cartUpdate = 'cart:update' (assets/events.js:115).
      // CartErrorEvent.eventName = 'cart:error'.
      document.addEventListener('cart:update', function () {
        setLoading(false);
      });
      document.addEventListener('cart:error', function () {
        setLoading(false);
      });
      // Safety: timeout van 8s zodat de button niet permanent loading-state
      // pakt als event-systeem hapert. 8s is meer dan genoeg voor zelfs
      // trage Shopify-stores.
      atcBtn.addEventListener('click', function () {
        setTimeout(function () { setLoading(false); }, 8000);
      });

      root.dataset.atcLoadingWired = '1';
    }

    // ---------- Edition selector (Standard / Plus) ----------
    // Twee aanklikbare opties boven de ATC. De gekozen optie zet de verborgen
    // variant-input (name="id") binnen het product-form + de getoonde prijs,
    // en klapt z'n eigen panel open terwijl de andere dichtklapt (CSS via
    // .is-selected). De mobiele sticky-ATC triggert dezelfde form, dus die
    // respecteert automatisch de gekozen editie.
    function initEdition(root) {
      var fs = root.querySelector('[data-rly-edition]');
      if (!fs || fs.dataset.editionWired === '1') return;
      var radios = Array.prototype.slice.call(fs.querySelectorAll('.rly-edition__radio'));
      if (!radios.length) return;
      var form = root.querySelector('product-form-component');
      var hiddenId = form ? form.querySelector('input[name="id"]') : root.querySelector('input[name="id"]');
      var priceNow = root.querySelector('.rly-pdp__price-now');

      function select(radio) {
        radios.forEach(function (r) {
          var opt = r.closest('[data-rly-opt]');
          var on = (r === radio);
          if (r.checked !== on) r.checked = on;
          if (opt) opt.classList.toggle('is-selected', on);
        });
        if (hiddenId && radio.dataset.variantId) {
          hiddenId.value = radio.dataset.variantId;
          hiddenId.dispatchEvent(new Event('change', { bubbles: true }));
          // Horizon's product-form leest de variant eerst uit ?variant= in de
          // URL en pas daarna uit de verborgen input. Sync de URL-param mee
          // zodat de juiste editie wordt toegevoegd, ook als er al een
          // ?variant= in de URL stond.
          try {
            var u = new URL(window.location.href);
            u.searchParams.set('variant', radio.dataset.variantId);
            window.history.replaceState({}, '', u);
          } catch (e) { /* no-op */ }
        }
        if (priceNow && radio.dataset.price) {
          priceNow.textContent = radio.dataset.price;
        }
      }

      fs.addEventListener('change', function (e) {
        var r = e.target && e.target.closest ? e.target.closest('.rly-edition__radio') : null;
        if (r) select(r);
      });

      // Hele optie-kaart klikbaar maken (niet alleen het label-rijtje), vooral op mobiel.
      // Klikken op een zoom-thumbnail wordt overgeslagen zodat die z'n eigen actie houdt.
      Array.prototype.slice.call(fs.querySelectorAll('[data-rly-opt]')).forEach(function (opt) {
        opt.addEventListener('click', function (e) {
          if (e.target && e.target.closest && e.target.closest('[data-rly-zoom]')) return;
          var r = opt.querySelector('.rly-edition__radio');
          if (r) select(r);
        });
      });

      var checked = null;
      for (var i = 0; i < radios.length; i++) {
        if (radios[i].checked) { checked = radios[i]; break; }
      }
      select(checked || radios[0]);

      fs.dataset.editionWired = '1';
    }

    function initEditionZoom(root) {
      if (!root || root.dataset.editionZoomWired === '1') return;
      var overlay = root.querySelector('[data-rly-edition-zoom]');
      var img = overlay && overlay.querySelector('[data-rly-edition-zoom-img]');
      var closeBtn = overlay && overlay.querySelector('[data-rly-edition-zoom-close]');
      if (!overlay || !img) return;
      if (overlay.parentNode !== document.body) document.body.appendChild(overlay);

      function close() {
        overlay.hidden = true;
        document.body.style.overflow = '';
      }
      root.addEventListener('click', function (e) {
        var t = e.target && e.target.closest ? e.target.closest('[data-rly-zoom]') : null;
        if (!t || !root.contains(t)) return;
        e.preventDefault();
        e.stopPropagation();
        var src = t.getAttribute('data-rly-zoom');
        if (!src) return;
        var thumbImg = t.querySelector('img');
        img.setAttribute('src', src);
        img.setAttribute('alt', thumbImg ? (thumbImg.getAttribute('alt') || '') : '');
        overlay.hidden = false;
        document.body.style.overflow = 'hidden';
      });
      if (closeBtn) closeBtn.addEventListener('click', close);
      overlay.addEventListener('click', function (e) { if (e.target === overlay) close(); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !overlay.hidden) close(); });

      root.dataset.editionZoomWired = '1';
    }

    // ---------- Color-variant gallery filter (Rally Vision) ----------
    // Single product met een Color-optie. Elke swatch filtert de thumbnail-rail
    // op data-color (afgeleid van de image ALT-text). Shared images (lege of
    // 'all' ALT) blijven altijd zichtbaar. We laten initGallery met rust en
    // integreren puur door thumbnail-wrappers te tonen/verbergen en de eerste
    // zichtbare thumb te .click()'en zodat de bestaande gallery-code de
    // featured image swapt.
    function initVisionColor(root) {
      if (!root) return;
      if (root.dataset.visionColorWired === '1') return;
      // Protect Vision gebruikt de bundle-picker; die wordt door initVisionBundle
      // afgehandeld. Hier vroeg uitstappen zodat de twee elkaar niet bijten.
      if (root.querySelector('[data-rly-bundle]')) return;

      var swatches = root.querySelectorAll('.rly-pdp__color-swatch[data-variant-id]');
      if (!swatches.length) return;

      var thumbs = root.querySelectorAll('[data-lightbox-trigger]');
      var variantInput = root.querySelector('product-form-component input[name="id"]') || root.querySelector('input[name="id"]');
      var colorValue = root.querySelector('.rly-pdp__color-value');

      function railItem(thumb) {
        // Verberg de buitenste rail-wrapper, niet alleen de trigger zelf.
        return thumb.closest('.rly-pdp__media') || thumb;
      }

      function applyColor(swatch) {
        var color = (swatch.getAttribute('data-color') || '').toLowerCase().trim();
        var variantId = swatch.getAttribute('data-variant-id');

        // is-on toggelen
        for (var s = 0; s < swatches.length; s++) {
          swatches[s].classList.toggle('is-on', swatches[s] === swatch);
        }

        // Color-label updaten
        if (colorValue) colorValue.textContent = swatch.getAttribute('aria-label') || color;

        // Thumbnails filteren: toon eigen kleur + shared ('' of 'all').
        var firstVisible = null;
        for (var t = 0; t < thumbs.length; t++) {
          var tc = (thumbs[t].dataset.color || '').toLowerCase().trim();
          var show = tc === color || tc === '' || tc === 'all';
          var wrap = railItem(thumbs[t]);
          if (show) {
            wrap.style.display = '';
            if (!firstVisible) firstVisible = thumbs[t];
          } else {
            wrap.style.display = 'none';
          }
        }

        // Eerste zichtbare thumb klikken zodat de gallery-code de featured image swapt.
        if (firstVisible) firstVisible.click();

        // Hidden variant-input + change-event voor de add-to-cart.
        if (variantInput && variantId) {
          variantInput.value = variantId;
          variantInput.dispatchEvent(new Event('change', { bubbles: true }));
        }

        // URL ?variant= bijwerken (best-effort).
        try {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', variantId);
          history.replaceState({}, '', url.toString());
        } catch (e) {}
      }

      for (var i = 0; i < swatches.length; i++) {
        (function (sw) {
          sw.addEventListener('click', function () { applyColor(sw); });
        })(swatches[i]);
      }

      // Init: kies de actieve swatch (.is-on) of de eerste, en draai zijn filter.
      var initial = root.querySelector('.rly-pdp__color-swatch[data-variant-id].is-on') || swatches[0];
      if (initial) applyColor(initial);

      root.dataset.visionColorWired = '1';
    }

    // ---------- Bundle picker (1 pair vs 2 pairs) — Rally Protect Vision ----------
    // Elke color-row (pickrow) heeft z'n eigen geselecteerde swatch. De ACTIEVE
    // optie z'n pair-#1 row stuurt de galerij-filter + de verborgen product-form
    // variant-input aan. Option 1 = single add; option 2 = beide gekozen
    // varianten in 1 /cart/add.js call (in initVisionBuyNow + de ATC-intercept).
    function initVisionBundle(root) {
      if (!root) return;
      if (root.dataset.visionColorWired === '1') return;

      var bundle = root.querySelector('[data-rly-bundle]');
      if (!bundle) return;

      var thumbs = root.querySelectorAll('[data-lightbox-trigger]');
      var variantInput = root.querySelector('product-form-component input[name="id"]') || root.querySelector('input[name="id"]');

      function railItem(thumb) {
        return thumb.closest('.rly-pdp__media') || thumb;
      }

      // Filter de galerij op de gegeven kleur en swap de featured image.
      // Wordt alleen aangeroepen voor pair-#1 van de actieve optie.
      function filterGallery(color) {
        color = (color || '').toLowerCase().trim();
        var firstVisible = null;
        for (var t = 0; t < thumbs.length; t++) {
          var tc = (thumbs[t].dataset.color || '').toLowerCase().trim();
          var show = tc === color || tc === '' || tc === 'all';
          var wrap = railItem(thumbs[t]);
          if (show) {
            wrap.style.display = '';
            if (!firstVisible) firstVisible = thumbs[t];
          } else {
            wrap.style.display = 'none';
          }
        }
        if (firstVisible) firstVisible.click();
      }

      function activeOpt() {
        return bundle.querySelector('.rly-pdp__bundle-opt.is-selected') ||
               bundle.querySelector('.rly-pdp__bundle-opt');
      }

      function selectedSwatch(pickrow) {
        return pickrow.querySelector('.rly-pdp__color-swatch.is-on[data-variant-id]') ||
               pickrow.querySelector('.rly-pdp__color-swatch[data-variant-id]');
      }

      // Sync galerij + verborgen variant-input op basis van de actieve optie z'n
      // pair-#1 swatch. data-vision-variants bewaart de gekozen varianten voor
      // de ATC/buy-now.
      function syncActive() {
        var opt = activeOpt();
        if (!opt) return;
        var rows = opt.querySelectorAll('.rly-pdp__bundle-pickrow');
        var pair1 = null;
        var pairIds = [];
        for (var r = 0; r < rows.length; r++) {
          var sw = selectedSwatch(rows[r]);
          if (!sw) continue;
          if (rows[r].getAttribute('data-pair') === '1') pair1 = sw;
          pairIds.push(sw.getAttribute('data-variant-id'));
        }
        if (pair1) {
          filterGallery(pair1.getAttribute('data-color'));
          var v1 = pair1.getAttribute('data-variant-id');
          if (variantInput && v1) {
            variantInput.value = v1;
            variantInput.dispatchEvent(new Event('change', { bubbles: true }));
          }
          try {
            var url = new URL(window.location.href);
            url.searchParams.set('variant', v1);
            history.replaceState({}, '', url.toString());
          } catch (e) {}
        }
        root.dataset.visionMode = opt.getAttribute('data-bundle-opt') || '1';
        root.dataset.visionVariants = pairIds.join(',');
      }

      // Per-row swatch-selectie: 1 is-on per pickrow.
      function selectSwatchInRow(pickrow, swatch) {
        var sws = pickrow.querySelectorAll('.rly-pdp__color-swatch[data-variant-id]');
        for (var s = 0; s < sws.length; s++) {
          sws[s].classList.toggle('is-on', sws[s] === swatch);
        }
        // "Color: <kleur>" label boven de swatches bijwerken.
        var cv = pickrow.querySelector('[data-bundle-colvalue]');
        if (cv) cv.textContent = swatch.getAttribute('aria-label') || swatch.getAttribute('data-color') || '';
        syncActive();
      }

      // Optie-kaart activeren (radio + visueel + body tonen/verbergen).
      function selectOption(opt) {
        var opts = bundle.querySelectorAll('.rly-pdp__bundle-opt');
        for (var o = 0; o < opts.length; o++) {
          var on = (opts[o] === opt);
          opts[o].classList.toggle('is-selected', on);
          var radio = opts[o].querySelector('.rly-pdp__bundle-radio');
          if (radio && radio.checked !== on) radio.checked = on;
        }
        syncActive();
      }

      // Klik-delegatie binnen de bundle: swatch in een row, of een optie-kaart.
      bundle.addEventListener('click', function (e) {
        var sw = e.target && e.target.closest ? e.target.closest('.rly-pdp__color-swatch[data-variant-id]') : null;
        if (sw && bundle.contains(sw)) {
          var pickrow = sw.closest('.rly-pdp__bundle-pickrow');
          if (pickrow) {
            var optOfRow = sw.closest('.rly-pdp__bundle-opt');
            if (optOfRow && !optOfRow.classList.contains('is-selected')) selectOption(optOfRow);
            selectSwatchInRow(pickrow, sw);
          }
          return;
        }
        var opt = e.target && e.target.closest ? e.target.closest('.rly-pdp__bundle-opt') : null;
        if (opt && bundle.contains(opt)) selectOption(opt);
      });

      // Radio-change (toetsenbord/label) ook afvangen.
      bundle.addEventListener('change', function (e) {
        var r = e.target && e.target.closest ? e.target.closest('.rly-pdp__bundle-radio') : null;
        if (!r) return;
        var opt = r.closest('.rly-pdp__bundle-opt');
        if (opt) selectOption(opt);
      });

      // Init: elke pickrow precies één is-on en sync de actieve optie.
      var allRows = bundle.querySelectorAll('.rly-pdp__bundle-pickrow');
      for (var i = 0; i < allRows.length; i++) {
        if (!allRows[i].querySelector('.rly-pdp__color-swatch.is-on[data-variant-id]')) {
          var firstSw = allRows[i].querySelector('.rly-pdp__color-swatch[data-variant-id]');
          if (firstSw) firstSw.classList.add('is-on');
        }
        // Init "Color:" label op de actieve swatch van elke rij.
        var onSw = allRows[i].querySelector('.rly-pdp__color-swatch.is-on[data-variant-id]');
        var cvi = allRows[i].querySelector('[data-bundle-colvalue]');
        if (onSw && cvi) cvi.textContent = onSw.getAttribute('aria-label') || onSw.getAttribute('data-color') || '';
      }
      var initialOpt = bundle.querySelector('.rly-pdp__bundle-opt[data-bundle-opt="1"]') ||
                       bundle.querySelector('.rly-pdp__bundle-opt');
      if (initialOpt) selectOption(initialOpt);

      root.dataset.visionColorWired = '1';
    }

    // Gekozen variant-ids voor de actieve optie (uit data-attrs die syncActive bijwerkt).
    function visionSelectedVariants(root) {
      return (root.dataset.visionVariants || '').split(',').filter(Boolean);
    }

    // Cart-drawer section-ids voor een gerichte /cart/add.js re-render.
    function visionCartSectionIds() {
      var ids = [];
      document.querySelectorAll('cart-items-component[data-section-id]').forEach(function (n) {
        var sid = n.getAttribute('data-section-id');
        if (sid && ids.indexOf(sid) === -1) ids.push(sid);
      });
      document.querySelectorAll('cart-icon[data-section-id]').forEach(function (n) {
        var sid = n.getAttribute('data-section-id');
        if (sid && ids.indexOf(sid) === -1) ids.push(sid);
      });
      return ids;
    }

    // Voeg beide varianten in EXACT één /cart/add.js call toe.
    function visionAddPair(variantIds) {
      var sids = visionCartSectionIds();
      var body = {
        items: variantIds.map(function (id) { return { id: Number(id), quantity: 1 }; })
      };
      if (sids.length) {
        body.sections = sids.join(',');
        body.sections_url = location.pathname;
      }
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(body)
      }).then(function (r) {
        if (!r.ok) throw new Error('add failed');
        return r.json();
      });
    }

    // Dispatch Horizon's cart:update zodat de cart-items section morpht en de drawer reageert.
    function visionDispatchCartUpdate(resp) {
      var sections = (resp && resp.sections) || {};
      var cart = (resp && resp.item_count !== undefined) ? resp : null;
      try {
        document.dispatchEvent(new CustomEvent('cart:update', {
          bubbles: true,
          detail: {
            resource: cart,
            sourceId: 'product-form-component',
            data: { source: 'product-form-component', sections: sections }
          }
        }));
      } catch (e) {}
    }

    // ---------- Buy it now (Rally Vision) ----------
    // Voegt de actueel geselecteerde variant toe via /cart/add.js en gaat
    // direct door naar checkout. Leest input[name="id"] op klik-moment,
    // zodat de kleur-swatch-keuze meegaat.
    function initVisionBuyNow(root) {
      if (!root) return;
      var btn = root.querySelector('[data-vision-buynow]');
      if (!btn || btn.dataset.buynowWired === '1') return;

      btn.addEventListener('click', function () {
        var mode = root.dataset.visionMode || '1';
        btn.classList.add('is-loading');
        btn.disabled = true;

        if (mode === '2') {
          // Twee varianten in 1 call, daarna door naar checkout.
          var ids = visionSelectedVariants(root);
          if (ids.length < 2) {
            var vi = root.querySelector('product-form-component input[name="id"]') || root.querySelector('input[name="id"]');
            ids = vi && vi.value ? [vi.value] : [];
          }
          if (!ids.length) { btn.classList.remove('is-loading'); btn.disabled = false; return; }
          visionAddPair(ids)
            .then(function () { window.location.href = '/checkout'; })
            .catch(function () { btn.classList.remove('is-loading'); btn.disabled = false; });
          return;
        }

        // Option 1: single variant.
        var variantInput = root.querySelector('product-form-component input[name="id"]') || root.querySelector('input[name="id"]');
        var variantId = variantInput ? variantInput.value : null;
        if (!variantId) { btn.classList.remove('is-loading'); btn.disabled = false; return; }

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: Number(variantId), quantity: 1 })
        })
          .then(function (r) {
            if (!r.ok) throw new Error('add failed');
            window.location.href = '/checkout';
          })
          .catch(function () {
            btn.classList.remove('is-loading');
            btn.disabled = false;
          });
      });

      btn.dataset.buynowWired = '1';
    }

    // ---------- ATC intercept voor 2-pair bundle (Rally Protect Vision) ----------
    // Option 1 actief: laat de normale product-form-flow lopen (verborgen
    // input[name="id"] staat al op pair-#1). Option 2 actief: onderschep de ATC,
    // voeg beide gekozen varianten in 1 call toe, open dan de cart drawer.
    function initVisionBundleAtc(root) {
      if (!root) return;
      var form = root.querySelector('product-form-component');
      if (!form || form.dataset.visionBundleAtcWired === '1') return;
      var addBtn = form.querySelector('button[name="add"]');
      if (!addBtn) return;

      addBtn.addEventListener('click', function (e) {
        var mode = root.dataset.visionMode || '1';
        if (mode !== '2') return; // Option 1: normale flow.

        var ids = visionSelectedVariants(root);
        if (ids.length < 2) return; // Veiligheid: val terug op normale flow.

        e.preventDefault();
        e.stopImmediatePropagation();

        if (addBtn.disabled || addBtn.getAttribute('aria-disabled') === 'true') return;
        addBtn.classList.add('is-loading');

        visionAddPair(ids)
          .then(function (resp) {
            visionDispatchCartUpdate(resp);
            var cd = document.querySelector('cart-drawer-component');
            if (cd) {
              if (typeof cd.open === 'function') cd.open();
              else if (typeof cd.showDialog === 'function') cd.showDialog();
            }
          })
          .catch(function () { /* no-op */ })
          .then(function () { addBtn.classList.remove('is-loading'); });
      }, true);

      form.dataset.visionBundleAtcWired = '1';
    }

    // ---------- Pack-bundel (Rally Foot Deo) ----------
    // 3 vaste-prijs packs zonder kleuren. Klik op een kaart selecteert de
    // bijbehorende variant via de verborgen product-form input; de normale ATC
    // voegt die variant toe (geen multi-variant add, geen cadeau).
    function initVisionPacks(root) {
      if (!root) return;
      var packs = root.querySelector('[data-rly-packs]');
      if (!packs || packs.dataset.packsWired === '1') return;
      var variantInput = root.querySelector('product-form-component input[name="id"]') || root.querySelector('input[name="id"]');

      function selectPack(opt) {
        var opts = packs.querySelectorAll('[data-pack-opt]');
        for (var i = 0; i < opts.length; i++) {
          var on = (opts[i] === opt);
          opts[i].classList.toggle('is-selected', on);
          var radio = opts[i].querySelector('.rly-pdp__bundle-radio');
          if (radio && radio.checked !== on) radio.checked = on;
        }
        var vid = opt.getAttribute('data-variant-id');
        if (variantInput && vid) {
          variantInput.value = vid;
          variantInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
        try {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', vid);
          history.replaceState({}, '', url.toString());
        } catch (e) {}
      }

      packs.addEventListener('click', function (e) {
        var opt = e.target && e.target.closest ? e.target.closest('[data-pack-opt]') : null;
        if (opt && packs.contains(opt)) selectPack(opt);
      });
      packs.addEventListener('change', function (e) {
        var r = e.target && e.target.closest ? e.target.closest('.rly-pdp__bundle-radio') : null;
        if (!r) return;
        var opt = r.closest('[data-pack-opt]');
        if (opt) selectPack(opt);
      });

      var initial = packs.querySelector('[data-pack-opt].is-selected') || packs.querySelector('[data-pack-opt]');
      if (initial) selectPack(initial);
      packs.dataset.packsWired = '1';
    }

    // ---------- Dots-navigatie (Rally Vision) ----------
    // Een puntje per zichtbare image (gekozen kleur + gedeeld). Klik op een
    // puntje klikt de (verborgen) thumb aan zodat alle bestaande gallery-
    // logica gewoon doorloopt. Hertekent op elke featured-wissel (swipe,
    // kleurwissel, lightbox-sync) via het vision:featured-change event.
    function initVisionDots(root) {
      if (!root) return;
      var wrap = root.querySelector('[data-vision-dots]');
      if (!wrap || wrap.dataset.dotsWired === '1') return;
      var triggers = Array.prototype.slice.call(root.querySelectorAll('.rly-pdp__gallery [data-lightbox-trigger]'));
      if (!triggers.length) return;

      function visibleTriggers() {
        return triggers.filter(function (t) {
          var w = t.closest('.rly-pdp__media') || t;
          return w.style.display !== 'none';
        });
      }

      function render() {
        var vis = visibleTriggers();
        wrap.innerHTML = '';
        vis.forEach(function (t, i) {
          var d = document.createElement('button');
          d.type = 'button';
          d.className = 'rly-pdp__dot' + (t.classList.contains('is-active') ? ' is-on' : '');
          d.setAttribute('aria-label', 'Image ' + (i + 1) + ' of ' + vis.length);
          d.addEventListener('click', function () { t.click(); });
          wrap.appendChild(d);
        });
      }

      root.addEventListener('vision:featured-change', render);
      render();
      wrap.dataset.dotsWired = '1';
    }

    function initSection(root) {
      if (!root) return;
      initAtcLoading(root);
      initAccordion(root);
      initGallery(root);
      initVisionColor(root);
      initVisionBundle(root);
      initVisionDots(root);
      initVisionBuyNow(root);
      initVisionBundleAtc(root);
      initVisionPacks(root);
      initGiftZoom(root);
      initEdition(root);
      initEditionZoom(root);
    }

    document.querySelectorAll('.rly-pdp').forEach(initSection);

    document.addEventListener('shopify:section:load', function (e) {
      var root = e.target && e.target.querySelector ? e.target.querySelector('.rly-pdp') : null;
      if (root) initSection(root);
    });

    /* ---------- Click rating -> scroll to reviews section ---------- */
    if (!window.rlyReviewsScrollWired) {
      window.rlyReviewsScrollWired = true;

      function rlyFindReviews() {
        // Cards Carousel (new app block) gebruikt .jdgm-cards-carousel,
        // vintage widget gebruikt .jdgm-carousel-wrapper / .jdgm-rev-widg.
        // Probeer alle bekende varianten + losse fallbacks.
        var selectors = [
          '.jdgm-cards-carousel',
          '.jdgm-carousel-wrapper',
          '.jdgm-revs-cards',
          '.jdgm-rev-widg',
          '.jdgm-carousel',
          '.jdgm-widget',
          '.jm-review-item',
          '[id^="judgeme"]',
          '[class*="jdgm-cards"]',
          '[class*="judgeme"]',
          '.rly-pr'
        ];
        for (var i = 0; i < selectors.length; i++) {
          var el = document.querySelector(selectors[i]);
          if (el) return el;
        }
        return document.querySelector('[class*="jdgm"]');
      }

      document.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-scroll-reviews]');
        if (!btn) return;
        e.preventDefault();
        var jdgm = rlyFindReviews();
        if (!jdgm) {
          if (window.console) console.warn('Rally: reviews-section niet gevonden op de pagina (Judge.me-widget nog niet geladen?)');
          return;
        }
        var section = jdgm.closest('[id^="shopify-section-"]') || jdgm;
        // Sticky-header offset compensatie via scroll-margin
        var prevMargin = section.style.scrollMarginTop;
        section.style.scrollMarginTop = '90px';
        section.scrollIntoView({ behavior: 'smooth', block: 'start' });
        // Reset na de scroll zodat we andere flows niet beïnvloeden
        setTimeout(function () { section.style.scrollMarginTop = prevMargin; }, 1000);
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rly-vision-video"] && !Shopify.designMode) return;
  try {
    
  // Speel af zodra ~35% van de video in beeld is, pauzeer erbuiten.
  // muted + playsinline zijn vereist voor autoplay op mobiel.
  document.querySelectorAll('.rly-vv').forEach(function (sec) {
    var v = sec.querySelector('video');
    if (!v || v.dataset.vvWired === '1') return;
    v.muted = true;
    v.loop = true;
    v.setAttribute('playsinline', '');
    var start = function () { var p = v.play(); if (p && p.catch) p.catch(function () {}); };
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) start();
          else v.pause();
        });
      }, { threshold: 0.35 });
      io.observe(v);
    } else {
      start();
    }
    v.dataset.vvWired = '1';
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rly-vnext-product"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-rvx-root]');
    if (!root) return;

    // ---- Lazy-load onder-de-vouw video's (POV): geen video-bytes tot in beeld ----
    var lazyVids = document.querySelectorAll('video[data-src]');
    if ('IntersectionObserver' in window) {
      var vio = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          var v = e.target;
          if (v.dataset.src && !v.src) {
            v.src = v.dataset.src;
            var pr = v.play();
            if (pr && pr.catch) pr.catch(function () {});
          }
          vio.unobserve(v);
        });
      }, { rootMargin: '200px' });
      for (var lv = 0; lv < lazyVids.length; lv++) vio.observe(lazyVids[lv]);
    } else {
      for (var lv2 = 0; lv2 < lazyVids.length; lv2++) { lazyVids[lv2].src = lazyVids[lv2].dataset.src; lazyVids[lv2].play().catch(function () {}); }
    }

    // ---- Kleur-swatches: wissel gallery-beelden + variant ----
    var swatches = root.querySelectorAll('[data-rvx-swatch]');
    var gimgs = root.querySelectorAll('[data-rvx-gimg]');
    var variantInput = root.querySelector('[data-rvx-variant-id]');
    var colorName = root.querySelector('[data-rvx-colorname]');
    var priceEl = root.querySelector('[data-rvx-price]');
    var wasEl = root.querySelector('[data-rvx-was]');
    var saveEl = root.querySelector('[data-rvx-save]');

    function applyColor(sw) {
      var color = sw.getAttribute('data-color');
      var key = color === 'black' ? 'black' : (color === 'white' ? 'white' : 'o');
      for (var i = 0; i < gimgs.length; i++) {
        var u = gimgs[i].getAttribute('data-' + key);
        if (u) gimgs[i].src = u;
      }
      for (var s = 0; s < swatches.length; s++) swatches[s].classList.toggle('is-on', swatches[s] === sw);
      var vid = sw.getAttribute('data-variant-id');
      if (variantInput && vid) {
        variantInput.value = vid;
        variantInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
      if (colorName) colorName.textContent = sw.getAttribute('aria-label') || '';
      // Prijsrij + ATC-labels meebewegen met de gekozen variant. Alle bedragen zijn
      // server-side geformatteerd met Shopify's money-filters — JS rekent nergens met geld.
      var pTxt = sw.getAttribute('data-price');
      if (priceEl && pTxt) priceEl.textContent = pTxt;
      var wasTxt = sw.getAttribute('data-was') || '';
      if (wasEl) { wasEl.textContent = wasTxt; wasEl.hidden = !wasTxt; }
      var saveTxt = sw.getAttribute('data-save') || '';
      if (saveEl) { saveEl.textContent = saveTxt; saveEl.hidden = !saveTxt; }
      if (atcBtn) {
        var lb = sw.getAttribute('data-label-base');
        var lw = sw.getAttribute('data-label-warr');
        var lp = sw.getAttribute('data-label-pb');
        var lpw = sw.getAttribute('data-label-pbwarr');
        if (lb) atcBtn.setAttribute('data-rvx-label-base', lb);
        if (lw) atcBtn.setAttribute('data-rvx-label-warr', lw);
        if (lp) atcBtn.setAttribute('data-rvx-label-pb', lp);
        if (lpw) atcBtn.setAttribute('data-rvx-label-pbwarr', lpw);
        updateAtcTotal();
      }
      try { var url = new URL(window.location.href); url.searchParams.set('variant', vid); history.replaceState({}, '', url.toString()); } catch (e) {}
    }
    for (var i = 0; i < swatches.length; i++) {
      (function (sw) { sw.addEventListener('click', function () { applyColor(sw); }); })(swatches[i]);
    }

    // Init (2026-08-28): komt de bezoeker binnen met ?variant= in de URL (bv.
    // doorgeklikt vanaf de collectiepagina met een gekozen kleur), zet dan ook
    // de gallery-foto's op die kleur. De rest (swatch, label, prijs, ATC) staat
    // server-side al goed. Zonder ?variant= gebeurt hier niets: gedrag identiek.
    try {
      if (new URL(window.location.href).searchParams.get('variant')) {
        var initSw = root.querySelector('[data-rvx-swatch].is-on');
        if (initSw) {
          var initColor = initSw.getAttribute('data-color');
          var initKey = initColor === 'black' ? 'black' : (initColor === 'white' ? 'white' : 'o');
          if (initKey !== 'o') {
            for (var gi = 0; gi < gimgs.length; gi++) {
              var gu = gimgs[gi].getAttribute('data-' + initKey);
              if (gu) gimgs[gi].src = gu;
            }
          }
        }
      }
    } catch (e) {}

    // ---- Mobiele gallery-slider (single slide + swipe + tik links/rechts) ----
    var gallery = root.querySelector('[data-rvx-gallery]');
    if (gallery) {
      var gtrack = gallery.querySelector('[data-rvx-gtrack]');
      var gfill = gallery.querySelector('[data-rvx-gprogfill]');
      var gcount = gtrack ? gtrack.children.length : 0;
      var gidx = 0;
      var gmq = window.matchMedia('(max-width: 749px)');
      function gload(i) {
        if (i < 0 || i >= gcount || !gtrack) return;
        var sl = gtrack.children[i];
        if (!sl) return;
        var im = sl.querySelector('img[loading="lazy"]');
        if (im) { im.loading = 'eager'; }
        var vd = sl.querySelector('video[data-gvsrc]');
        if (vd && !vd.getAttribute('src')) { vd.setAttribute('src', vd.getAttribute('data-gvsrc')); vd.load(); }
      }
      function gprefetch() {
        if (!gmq.matches) { for (var i = 0; i < gcount; i++) gload(i); return; }
        gload(gidx); gload(gidx + 1); gload(gidx + 2);
      }
      function gset(i) {
        if (!gcount) return;
        gidx = (i + gcount) % gcount;
        if (gtrack) gtrack.style.setProperty('--gx', (-gidx * 100) + '%');
        if (gfill) gfill.style.width = (((gidx + 1) / gcount) * 100) + '%';
        gprefetch();
      }
      // Tik-navigatie (links/rechts tappen) bewust verwijderd (2026-07-13):
      // alleen swipen bladert door de gallery op mobiel.
      var gsx = null;
      gallery.addEventListener('touchstart', function (e) { gsx = e.touches[0].clientX; }, { passive: true });
      gallery.addEventListener('touchend', function (e) {
        if (gsx === null || !gmq.matches) { gsx = null; return; }
        var dx = e.changedTouches[0].clientX - gsx;
        if (dx < -30) gset(gidx + 1); else if (dx > 30) gset(gidx - 1);
        gsx = null;
      });
      if (gmq.addEventListener) gmq.addEventListener('change', function () { gset(gidx); });
      gset(0);
    }

    // ---- Mini review carousel ----
    var miniq = root.querySelector('[data-rvx-miniq]');
    if (miniq) {
      var qData = [
        { n: 'Dave R.', t: 'One press and it records. Easier than any camera setup I have owned, and I have owned a few.' },
        { n: 'Tom H.', t: 'You forget they are on. They look and feel like regular riding glasses, not another gadget strapped to my head.' },
        { n: 'Susan M.', t: 'Smooth clips straight off the glasses, no editing. My morning rides finally look the way they felt.' }
      ];
      var qi = 0;
      var qText = miniq.querySelector('[data-rvx-qtext]');
      var qName = miniq.querySelector('[data-rvx-qname]');
      var qAv = miniq.querySelector('[data-rvx-qav]');
      var qDots = miniq.querySelectorAll('[data-rvx-qdot]');
      function setQ(i) {
        qi = (i + qData.length) % qData.length;
        if (qText) qText.textContent = qData[qi].t;
        if (qName) qName.textContent = qData[qi].n;
        if (qAv) { var a = miniq.getAttribute('data-av' + qi); if (a) qAv.src = a; }
        for (var d = 0; d < qDots.length; d++) qDots[d].classList.toggle('is-on', d === qi);
      }
      var qPrev = miniq.querySelector('[data-rvx-qprev]');
      var qNext = miniq.querySelector('[data-rvx-qnext]');
      if (qPrev) qPrev.addEventListener('click', function () { setQ(qi - 1); });
      if (qNext) qNext.addEventListener('click', function () { setQ(qi + 1); });
      for (var d = 0; d < qDots.length; d++) {
        (function (idx) { qDots[idx].addEventListener('click', function () { setQ(idx); }); })(d);
      }
      var qx = null;
      miniq.addEventListener('touchstart', function (e) { qx = e.touches[0].clientX; }, { passive: true });
      miniq.addEventListener('touchend', function (e) {
        if (qx === null) return;
        var dx = e.changedTouches[0].clientX - qx;
        if (dx < -30) setQ(qi + 1); else if (dx > 30) setQ(qi - 1);
        qx = null;
      });
    }

    // ---- Battery tab: With power bank / Glasses alone ----
    var batt = root.querySelector('[data-rvx-battery]');
    if (batt) {
      var battTabs = batt.querySelectorAll('[data-rvx-batt]');
      for (var b = 0; b < battTabs.length; b++) {
        (function (btn) {
          btn.addEventListener('click', function () {
            batt.classList.toggle('is-alone', btn.getAttribute('data-rvx-batt') === 'alone');
            for (var k = 0; k < battTabs.length; k++) battTabs[k].classList.toggle('is-on', battTabs[k] === btn);
          });
        })(battTabs[b]);
      }
    }

    // ---- Add-on: warranty toggle (past ATC-totaal aan) ----
    // Geen prijs-rekenwerk in JS: de labels (met en zonder warranty) zijn server-side
    // gerenderd met money-filters en staan als data-attributen op de knop. applyColor()
    // ververst die attributen per variant; hier wisselen we alleen de juiste string in.
    var atcBtn = root.querySelector('.rvx__atc');
    var warrOn = false;
    function updateAtcTotal() {
      if (!atcBtn) return;
      var key = pbOn && warrOn ? 'data-rvx-label-pbwarr' : (pbOn ? 'data-rvx-label-pb' : (warrOn ? 'data-rvx-label-warr' : 'data-rvx-label-base'));
      var label = atcBtn.getAttribute(key);
      if (!label) return;
      if (!atcBtn.disabled) {
        var labelEl = atcBtn.querySelector('.rvx__atc-label');
        if (labelEl) { labelEl.textContent = label; } else { atcBtn.textContent = label; }
      }
      var stickyBtn = root.querySelector('[data-rvx-sticky-trigger]');
      if (stickyBtn && !stickyBtn.disabled) stickyBtn.textContent = label;
    }
    // ---- Add-on: power bank aan/uit (BETAALDE add-on, default UIT — 29-09) ----
    // Zelfde denkmodel als de warranty-knop: puur lokale UI-stand + knoplabel.
    // Geen cart-attributes en geen netwerk bij het togglen; de keuze reist mee
    // in de add-payload van de ATC. Bewust GEEN sync met cart:update-events:
    // de toggle mag nooit vanzelf omspringen (dat zou ongevraagd $25 bijkopen).
    var giftCard = root.querySelector('[data-rvx-gift]');
    var pbOn = false;
    function syncPb(on) {
      pbOn = !!on;
      if (giftCard) {
        giftCard.classList.toggle('is-off', !pbOn);
        giftCard.setAttribute('aria-pressed', pbOn ? 'true' : 'false');
      }
      updateAtcTotal();
    }
    if (giftCard) {
      var togglePb = function () { syncPb(!pbOn); };
      giftCard.addEventListener('click', function (e) {
        if (e.target.closest('[data-rvx-pbzoom]')) return;
        togglePb();
      });
      giftCard.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); togglePb(); }
      });
    }
    // Warranty-stand syncen met de opgeslagen keuze in de winkelwagen. Bewust
    // BUITEN de pb-guard: dit moet ook werken los van het pb-blok.
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (!cart || !cart.attributes) return;
        syncWarr(!!cart.attributes.rly_warranty);
      }).catch(function () {});
    // Blijf gesynct met drawer/motor via cart:update — ALLEEN voor de warranty
    // (attribute-gedreven). De pb-toggle is lokaal en blijft hier buiten.
    document.addEventListener('cart:update', function (e) {
      var c = e && e.detail && e.detail.resource;
      if (!c || !c.attributes) return;
      var src = (e.detail.data && e.detail.data.source) || '';
      if (src !== 'rvx-warr-toggle') syncWarr(!!c.attributes.rly_warranty);
    });

    var warrBtn = root.querySelector('[data-rvx-warranty]');
    // Zet de PDP-toggle-stand (UI + knoplabel) zonder netwerk — gebruikt door
    // load-sync en door cart:update events (bv. toggle in de drawer omgezet).
    function syncWarr(on) {
      warrOn = !!on;
      if (warrBtn) {
        warrBtn.classList.toggle('is-on', warrOn);
        warrBtn.setAttribute('aria-pressed', warrOn ? 'true' : 'false');
      }
      updateAtcTotal();
    }
    if (warrBtn) {
      warrBtn.addEventListener('click', function (e) {
        if (e.target.closest('[data-rvx-warrinfo]')) return;
        syncWarr(!warrOn);
        // Persisteer de keuze als cart-attribute (zelfde schakelaar als het
        // warranty-blok in de drawer). Zit de bril al in de cart, dan schaalt
        // de motor de warranty er direct bij of af (via het event hieronder).
        fetch('/cart/update.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ attributes: { rly_warranty: warrOn ? 'true' : '' }, sections: rvxSectionIds().join(','), sections_url: window.location.pathname })
        }).then(function (r) { return r.json(); }).then(function (resp) {
          rvxDispatchCartUpdate(resp, resp.sections || {}, 'rvx-warr-toggle');
        }).catch(function () {});
      });
    }

    // ---- ADD TO CART: alles in ÉÉN call ----
    // De knop is [data-rvx-owned]: rly-auto-gift.js en Horizon's product-form
    // blijven er volledig vanaf. Wij sturen bril + power bank (indien aan) +
    // warranty (indien aan) in één /cart/add.js met sections-render, halen de
    // verse cart op en dispatchen het CartUpdateEvent. De drawer opent direct
    // met skeleton en morpht naar de definitieve inhoud — geen reparatie-rondes.
    var pbVid = atcBtn ? atcBtn.getAttribute('data-rvx-pb-vid') : '';
    var warrVid = atcBtn ? atcBtn.getAttribute('data-rvx-warr-vid') : '';
    function rvxWarrantyItems() { return (warrOn && warrVid) ? [{ id: Number(warrVid), quantity: 1 }] : []; }

    function rvxSectionIds() {
      var ids = [];
      var nodes = document.querySelectorAll('cart-items-component[data-section-id], cart-icon[data-section-id]');
      for (var i = 0; i < nodes.length; i++) {
        var sid = nodes[i].getAttribute('data-section-id');
        if (sid && ids.indexOf(sid) === -1) ids.push(sid);
      }
      return ids;
    }
    function rvxSkeleton(show) {
      document.body.classList.toggle('rly-cart-skeleton-active', !!show);
      var sk = document.querySelector('.rly-cart-skeleton');
      if (sk) { if (show) sk.removeAttribute('hidden'); else sk.setAttribute('hidden', ''); }
    }
    function rvxOpenDrawer() {
      var cd = document.querySelector('cart-drawer-component');
      if (!cd) return;
      if (typeof cd.open === 'function') cd.open();
      else if (typeof cd.showDialog === 'function') cd.showDialog();
    }
    function rvxVisibleCount(cart) {
      if (!cart || !cart.items) return 0;
      var n = 0;
      for (var i = 0; i < cart.items.length; i++) {
        var it = cart.items[i];
        var isGift = it.properties && (it.properties._gift === 'true' || it.properties._gift === true);
        if (!isGift) n += it.quantity || 0;
      }
      return n;
    }
    function rvxDispatchCartUpdate(cart, sections, source) {
      try {
        document.dispatchEvent(new CustomEvent('cart:update', {
          bubbles: true,
          detail: {
            resource: cart,
            sourceId: source || 'rly-vnext-atc',
            data: { source: source || 'rly-vnext-atc', sections: sections || {}, itemCount: rvxVisibleCount(cart) }
          }
        }));
      } catch (err) { /* event-dispatch mag nooit de add blokkeren */ }
    }

    var atcBusy = false;
    function rvxAddToCart() {
      if (atcBusy || !atcBtn || atcBtn.disabled) return;
      var vid = variantInput ? Number(variantInput.value) : 0;
      if (!vid) return;
      atcBusy = true;
      var labelEl = atcBtn.querySelector('.rvx__atc-label');
      if (labelEl) labelEl.textContent = 'Adding…';
      atcBtn.style.opacity = '0.75';

      var items = [{ id: vid, quantity: 1 }];
      if (pbOn && pbVid) items.push({ id: Number(pbVid), quantity: 1 });
      items = items.concat(rvxWarrantyItems());

      rvxSkeleton(true);
      rvxOpenDrawer();

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items, sections: rvxSectionIds().join(','), sections_url: window.location.pathname })
      })
        .then(function (r) { return r.json().then(function (json) { return { ok: r.ok, json: json }; }); })
        .then(function (res) {
          if (!res.ok || res.json.status) {
            throw new Error((res.json && (res.json.description || res.json.message)) || 'add failed');
          }
          // Volledige cart erbij halen (1 lichte GET) zodat alle componenten
          // (bubble, product-forms, toggles) met échte data kunnen syncen.
          return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
            .then(function (r) { return r.json(); })
            .catch(function () { return null; })
            .then(function (cart) {
              rvxDispatchCartUpdate(cart, res.json.sections || {});
              rvxSkeleton(false);
              updateAtcTotal(); // label terug naar de juiste actuele prijs
              atcBtn.style.opacity = '';
            });
        })
        .catch(function () {
          rvxSkeleton(false);
          if (labelEl) {
            labelEl.textContent = 'Something went wrong — try again';
            setTimeout(function () { updateAtcTotal(); }, 2500);
          }
          atcBtn.style.opacity = '';
        })
        .then(function () { atcBusy = false; });
    }

    if (atcBtn) {
      atcBtn.addEventListener('click', function (e) {
        e.preventDefault();          // blokkeer de native form-submit (Horizon)
        e.stopPropagation();         // en Horizon's on:click delegatie
        rvxAddToCart();
      });
    }

    // ---- Mobiele sticky ATC-balk: triggert de echte ADD TO CART ----
    var stickyBar = root.querySelector('[data-rvx-sticky]');
    if (stickyBar && atcBtn) {
      var stickyTrig = stickyBar.querySelector('[data-rvx-sticky-trigger]');
      if (stickyTrig) stickyTrig.addEventListener('click', function () { atcBtn.click(); });
    }
    // Pas tonen zodra de ATC-knop BOVEN de viewport uit beeld is gescrold;
    // zolang hij zichtbaar is (of nog onder de fold ligt) blijft de balk
    // verborgen (2026-07-13; Buy it now-restant opgeruimd 29-09).
    var stickyAnchor = atcBtn;
    if (stickyBar && stickyAnchor && 'IntersectionObserver' in window) {
      var sio = new IntersectionObserver(function (entries) {
        var en = entries[0];
        var voorbijGescrold = !en.isIntersecting && en.boundingClientRect.top < 0;
        stickyBar.classList.toggle('is-visible', voorbijGescrold);
      }, { threshold: 0 });
      sio.observe(stickyAnchor);
    } else if (stickyBar) {
      stickyBar.classList.add('is-visible'); // fallback: oud gedrag
    }

    // ---- Overlays: warranty drawer + power bank zoom ----
    function openEl(el) { if (el) { el.hidden = false; document.body.style.overflow = 'hidden'; } }
    function closeEl(el) { if (el) { el.hidden = true; document.body.style.overflow = ''; } }
    var drawer = root.querySelector('[data-rvx-drawer]');
    var pbModal = root.querySelector('[data-rvx-pbzoom-modal]');
    function bind(sel, fn) { var n = root.querySelectorAll(sel); for (var i = 0; i < n.length; i++) n[i].addEventListener('click', fn); }
    bind('[data-rvx-warrinfo]', function (e) { e.stopPropagation(); openEl(drawer); });
    bind('[data-rvx-drawer-close]', function () { closeEl(drawer); });
    bind('[data-rvx-pbzoom]', function () { openEl(pbModal); });
    bind('[data-rvx-pbzoom-close]', function () { closeEl(pbModal); });

    // Review-foto lightbox: klik op een review-foto opent hem groot.
    var imgModal = root.querySelector('[data-rvx-imgmodal]');
    var imgTarget = imgModal ? imgModal.querySelector('[data-rvx-imgtarget]') : null;
    function openImg(src, alt) { if (imgModal && imgTarget && src) { imgTarget.src = src; imgTarget.alt = alt || ''; openEl(imgModal); } }
    function closeImg() { closeEl(imgModal); if (imgTarget) imgTarget.removeAttribute('src'); }
    root.addEventListener('click', function (e) {
      var ph = e.target.closest ? e.target.closest('[data-rvx-revphoto]') : null;
      if (!ph) return;
      var im = ph.querySelector('img') || ph;
      openImg(im.getAttribute('data-full') || im.getAttribute('src'), im.getAttribute('alt'));
    });
    bind('[data-rvx-imgclose]', closeImg);

    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { closeEl(drawer); closeEl(pbModal); closeImg(); } });

    // ---- Reviews: pagination (5 per page) ----
    var revPagesWrap = root.querySelector('[data-rvx-revpages]');
    var revPager = root.querySelector('[data-rvx-revpager]');
    if (revPagesWrap && revPager) {
      var revTotal = parseInt(revPagesWrap.getAttribute('data-rvx-revcount'), 10) || 1;
      var revCur = 1;
      var revSec = revPagesWrap.closest('.rvx__reviews');
      // Materialiseer een pagina uit zijn <template> (pages 2+ laden pas bij bezoek)
      function revMaterialize(n) {
        var pg = revPagesWrap.querySelector('[data-rvx-revpage="' + n + '"]');
        if (pg) return pg;
        var tpl = revPagesWrap.querySelector('template[data-rvx-revtpl="' + n + '"]');
        if (!tpl) return null;
        tpl.parentNode.insertBefore(tpl.content.cloneNode(true), tpl);
        tpl.parentNode.removeChild(tpl);
        return revPagesWrap.querySelector('[data-rvx-revpage="' + n + '"]');
      }
      function revBtn(label, page, opts) {
        opts = opts || {};
        var b = document.createElement('button');
        b.type = 'button';
        b.textContent = label;
        if (opts.on) b.className = 'is-on';
        if (opts.disabled) b.disabled = true;
        if (opts.aria) b.setAttribute('aria-label', opts.aria);
        if (page) b.addEventListener('click', function () { revGo(page); });
        return b;
      }
      function revRender() {
        var pages = revPagesWrap.querySelectorAll('[data-rvx-revpage]');
        for (var i = 0; i < pages.length; i++) { pages[i].hidden = pages[i].getAttribute('data-rvx-revpage') !== String(revCur); }
        revPager.innerHTML = '';
        revPager.appendChild(revBtn('‹', revCur > 1 ? revCur - 1 : null, { disabled: revCur === 1, aria: 'Previous page' }));
        // Schuivend venster van altijd 3 nummers (huidige in het midden, geklemd aan de randen)
        var start = Math.min(Math.max(revCur - 1, 1), Math.max(revTotal - 2, 1));
        for (var p = start; p < start + 3 && p <= revTotal; p++) {
          revPager.appendChild(revBtn(String(p), p, { on: p === revCur }));
        }
        revPager.appendChild(revBtn('›', revCur < revTotal ? revCur + 1 : null, { disabled: revCur === revTotal, aria: 'Next page' }));
      }
      function revGo(n) {
        revMaterialize(n);
        revCur = n;
        revRender();
        if (revSec) { var y = revSec.getBoundingClientRect().top + window.pageYOffset - 80; window.scrollTo({ top: y, behavior: 'smooth' }); }
      }
      revRender();
    }

    // ---- ABConvert prijstest-koppeling (sept 2026) ----
    // ABConvert past de cart-prijs aan via Shopify Functions, maar hun script
    // herkent onze custom prijsplekken niet (selectors van standaardthema's).
    // Daarom vragen we hier zelf per variant de groepsprijs op via hun
    // browser-API en werken we alle prijsteksten + data-attributen bij.
    // Geen ABConvert, geen lopende test of controlegroep: er gebeurt niks en
    // de server-gerenderde prijzen blijven staan.
    var rvxAbcKlaar = false;
    function rvxAbcFmt(a) {
      if (a == null || isNaN(a)) return '';
      return '$' + (a % 1 === 0 ? String(a) : a.toFixed(2));
    }
    function rvxAbcPrijzen() {
      if (rvxAbcKlaar) return true;
      try {
        if (!window.ABConvert || typeof window.ABConvert.getPriceByVariantId !== 'function') return false;
        var warrCents = parseInt(atcBtn && atcBtn.getAttribute('data-rvx-warr-cents'), 10);
        var warr = isNaN(warrCents) ? 29 : warrCents / 100;
        var pbCents = parseInt(atcBtn && atcBtn.getAttribute('data-rvx-pb-cents'), 10);
        var pb = isNaN(pbCents) ? 25 : pbCents / 100;
        var gezien = 0, geraakt = 0;
        for (var i = 0; i < swatches.length; i++) {
          var sw = swatches[i];
          var info = null;
          try { info = window.ABConvert.getPriceByVariantId(sw.getAttribute('data-variant-id')); } catch (e) {}
          if (!info || !info.testGroup) continue;
          gezien++;
          if (info.testGroup.control) continue;
          var a = Number(info.amount);
          var c = Number(info.compareAtAmount);
          if (!a) continue;
          var heeftWas = c && c > a;
          sw.setAttribute('data-price', rvxAbcFmt(a));
          sw.setAttribute('data-was', heeftWas ? rvxAbcFmt(c) : '');
          sw.setAttribute('data-save', heeftWas ? 'Save ' + rvxAbcFmt(c - a) : '');
          sw.setAttribute('data-label-base', 'Add to cart — ' + rvxAbcFmt(a));
          sw.setAttribute('data-label-warr', 'Add to cart — ' + rvxAbcFmt(a + warr));
          sw.setAttribute('data-label-pb', 'Add to cart — ' + rvxAbcFmt(a + pb));
          sw.setAttribute('data-label-pbwarr', 'Add to cart — ' + rvxAbcFmt(a + warr + pb));
          geraakt++;
        }
        if (gezien === 0) return false; // API nog niet klaar: opnieuw proberen
        rvxAbcKlaar = true;
        if (geraakt === 0) return true; // controlegroep: niks te doen
        // Zichtbare teksten bijwerken vanuit de actieve swatch (zelfde pad als
        // applyColor, maar zonder gallery/URL-bijwerkingen).
        var actief = root.querySelector('[data-rvx-swatch].is-on') || swatches[0];
        if (actief) {
          var pTxt = actief.getAttribute('data-price');
          if (priceEl && pTxt) priceEl.textContent = pTxt;
          var wasTxt = actief.getAttribute('data-was') || '';
          if (wasEl) { wasEl.textContent = wasTxt; wasEl.hidden = !wasTxt; }
          var saveTxt = actief.getAttribute('data-save') || '';
          if (saveEl) { saveEl.textContent = saveTxt; saveEl.hidden = !saveTxt; }
          if (atcBtn) {
            var lb = actief.getAttribute('data-label-base');
            var lw = actief.getAttribute('data-label-warr');
            var lp = actief.getAttribute('data-label-pb');
            var lpw = actief.getAttribute('data-label-pbwarr');
            if (lb) atcBtn.setAttribute('data-rvx-label-base', lb);
            if (lw) atcBtn.setAttribute('data-rvx-label-warr', lw);
            if (lp) atcBtn.setAttribute('data-rvx-label-pb', lp);
            if (lpw) atcBtn.setAttribute('data-rvx-label-pbwarr', lpw);
            updateAtcTotal();
          }
        }
        return true;
      } catch (e) { return false; }
    }
    (function rvxAbcStart() {
      if (rvxAbcPrijzen()) return;
      try {
        if (window.ABConvert && typeof window.ABConvert.onReady === 'function') {
          window.ABConvert.onReady(function () { rvxAbcPrijzen(); });
        }
      } catch (e) {}
      var pogingen = 0;
      var timer = setInterval(function () {
        pogingen++;
        if (rvxAbcPrijzen() || pogingen >= 25) clearInterval(timer);
      }, 400);
    })();

  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rly-why-pain"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-rly-why-play]');
    if (!btn) return;
    var media = btn.closest('.rly-why__media');
    var video = media && media.querySelector('[data-rly-why-video]');
    if (!video) return;
    video.setAttribute('controls', '');
    btn.style.display = 'none';
    var p = video.play();
    if (p && p.catch) { p.catch(function () {}); }
  });

  } catch(e) { console.error(e); }
})();
})();
